import './style.css';

import normalizeWheel from 'normalize-wheel-es';

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
// import { FlyControls } from 'three/examples/jsm/controls/FlyControls';
// import { Vector2, Vector3 } from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';

import GUI, { FunctionController } from 'lil-gui';
import Stats from 'three/examples/jsm/libs/stats.module.js';

import { gsap, random } from 'gsap';
import { Observer } from 'gsap/Observer';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import MeshReflectorMaterial from './utils/MeshReflectorMaterial.js';

gsap.registerPlugin(Observer);
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

import data from '../src/data.js';
import gsapCore from 'gsap/gsap-core';

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// GLOBAL VARS AND UTILS
//////////////////////////////////////////////////////////////////

// 0 = in desrt
// 1 = landed intro
// 2 = about
// 3 = origin
var scene_state = 'intro';
var scene_history = ['intro'];
// console.log('hist', scene_history);

var global_instanced_scale = { val: 1 };

var is_debug = false;
var show_preloader = true;
var use_orbit = false;

if (is_debug) {
    console.log('data', data);
}

/// CHECK SAFARI
var isSafariDesktop = navigator.vendor.match(/apple/i) ? (window.innerWidth > 1024 ? true : false) : false;

if (is_debug) {
    console.log('isSafariPC', isSafariDesktop);
}

//// CHECK WINDOWS
function getOS() {
    let userAgent = window.navigator.userAgent.toLowerCase(),
        macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
        windowsPlatforms = /(win32|win64|windows|wince)/i,
        iosPlatforms = /(iphone|ipad|ipod)/i,
        os = null;

    if (macosPlatforms.test(userAgent)) {
        os = 'macos';
    } else if (iosPlatforms.test(userAgent)) {
        os = 'ios';
        window.createImageBitmap = undefined;
    } else if (windowsPlatforms.test(userAgent)) {
        os = 'windows';
    } else if (/android/.test(userAgent)) {
        os = 'android';
    } else if (!os && /linux/.test(userAgent)) {
        os = 'linux';
    }
    //
    return os;
}

var os = getOS();
var isEdge = /Edg/.test(navigator.userAgent);

if (is_debug) {
    console.log(os, 'isEdge:', isEdge);
}

function randomNum(min, max) {
    return Math.floor(min + Math.random() * (max - min + 1));
}

/// STATS and GUI

if (is_debug) {
    var stats = Stats();
    stats.dom.setAttribute('class', 'stats-gui');
    document.body.appendChild(stats.dom);
}

var add_gui = true;

if (add_gui) {
    var gui = new GUI();
    // gui.hide(); // Hide completely

    gui.close();
    if (window.innerWidth < 768) {
        // gui.close();
    }
}

////
//// GLOBAL VARS

var scene, renderer, camera;
var camera_position;
var mixer;

var active_room = 0;

var can_perspective = false;
// 0 - intro , 1 - about , 2 - origin , 3 - contact
var camera_original_position = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];
var camera_original_quaternion = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];

let INTERSECTED;
const raycaster = new THREE.Raycaster();
raycaster.far = 2000;
const pointer = new THREE.Vector2(-2, -2);

var params = {
    target_scrolly: 0,
    current_scrolly: 0,
    ease_scrolly: 0.075,
    scrollspeed: /*24000*/ 10000,
    speed_multiplier: 1,
    mouse: {
        target_x: 0,
        current_x: 0,
        target_y: 0,
        current_y: 0,
        ease: 0.02,
    },
    frametime: 0,
    cameraFOV: window.innerWidth > 768 ? 80 : 110,
    frametime_steady: 0,

    jumpto_start: function () {
        params.frametime = 0;
        updateSceneFromGUI();
    },
    jumpto_dome: function () {
        params.frametime = 10.4;
        updateSceneFromGUI();
    },
    toggleInstance: function () {
        toggleInstanced();
    },

    autoScroll: false,
};

if (add_gui) {
    gui.add(params, 'autoScroll').onChange(updateSceneFromGUI);
    var controller_timeframe = gui.add(params, 'frametime', 0.0, 46, 0.0001).onChange(updateSceneFromGUI);
    gui.add(params, 'cameraFOV', 40, 120, 0.05).onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_start').onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_dome').onChange(updateSceneFromGUI);

    gui.add(params, 'toggleInstance');
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// THREEJS
//////////////////////////////////////////////////////////////////

// LOADING VARS
var loaded_models = 0;
var total_models = 3;
var all_loaded = false;

var domWebGL = document.createElement('div');
domWebGL.setAttribute('class', 'three-canvas-wrap');
document.body.appendChild(domWebGL);

// SCENE
scene = new THREE.Scene();
// scene.background = new THREE.Color(0xffffff);

// RENDER
if (os == 'ios') {
    console.log('is ios');
    renderer = new THREE.WebGL1Renderer({ alpha: true, antialias: true });
} else {
    renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
}
renderer.setClearColor(0xeeeeee, 1);
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(window.devicePixelRatio);
renderer.powerPreference = 'high-performance';
// renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.outputEncoding = THREE.sRGBEncoding;
domWebGL.appendChild(renderer.domElement);

// CAMERA
camera = new THREE.PerspectiveCamera(90, window.innerWidth / window.innerHeight, 1, 100000000);
camera.aspect = window.innerWidth / window.innerHeight;
camera.updateProjectionMatrix();

if (use_orbit) {
    var controls = new OrbitControls(camera, renderer.domElement);
    camera.position.z = 5000;
}

// LIGHTS
const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
directionalLight.position.x = -2000;
directionalLight.position.y = 3500;
directionalLight.position.z = -2000;
scene.add(directionalLight);

const dirlight_helper = new THREE.DirectionalLightHelper(directionalLight, 100);
// scene.add(dirlight_helper);

//// ENVMAP
// const hdrEquirect = new RGBELoader().load('./textures/environmentMaps/empty_warehouse_01_rsz.hdr', () => {
//     hdrEquirect.mapping = THREE.EquirectangularReflectionMapping;
// });

var pmremGenerator_texture;
new RGBELoader().load('./textures/hdr/Deeponde_HDRI_hdr_v07_grey.hdr', (tex) => {
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    pmremGenerator_texture = pmremGenerator.fromEquirectangular(tex).texture;
    scene.environment = scene.background = pmremGenerator_texture;
    pmremGenerator_texture.encoding = THREE.sRGBEncoding;
    // scene.environment = pmremGenerator.fromEquirectangular(tex).texture;
    // console.log(pmremGenerator_texture);
});

// LOADERS
const textureLoader = new THREE.TextureLoader();
const modelLoader = new GLTFLoader();
const dracoLoader = new DRACOLoader();
// dracoLoader.setDecoderPath('js/three/draco/');
dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
modelLoader.setDRACOLoader(dracoLoader);

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// LOAD GLB - CAMERA
//////////////////////////////////////////////////////////////////

var camera_gltf;
var camera_animations;

var loc_intro = {
    land: 0,
    start: 0,
};
var loc_about = {
    land: 13.1,
    start: 14.3,
};
var loc_origin = {
    land: 20.28,
    start: 22.9,
};
var loc_contact = {
    land: 29,
    start: 31.4,
    end: 37.5,
};
function playCamera(from, to) {
    // if (camindex == 0) {
    //     //INTRO A
    //     var fromgo = 0;
    //     var togo = 12.82;
    // } else if (camindex == 1) {
    //     // A -> B - ABOUT TO ORIGIN
    //     var fromgo = 13.9;
    //     var togo = 20.3;
    // } else if (camindex == 2) {
    //     // B -> C - ORIGIN TO CONTACT
    //     var fromgo = 22.7;
    //     var togo = 29.0;
    // } else if (camindex == 3) {
    //     // C -> A - CONTACT TO ABOUT
    //     var fromgo = 31.2;
    //     var togo = 37.6;
    // } else if (camindex == 4) {
    //     // A -> C - ABOUT TO CONTACT
    //     var fromgo = 42.4;
    //     var togo = 48.55;
    // } else if (camindex == 5) {
    //     // C -> B - CONTACT TO ORIGIN
    //     var fromgo = 50.8;
    //     var togo = 57.2;
    // } else if (camindex == 6) {
    //     // B -> A - ORIGIN TO ABOUT
    //     var fromgo = 59.3;
    //     var togo = 65.9;
    // } else {
    //     var fromgo = 0;
    //     var togo = 12.6;
    // }

    gsap.fromTo(
        params,
        { frametime: from.start },
        {
            frametime: to.land,
            delay: 0.3,
            // duration: 1,
            duration: 2,
            ease: 'power1.inOut',
            onUpdate: (ev) => {
                updateSceneFromGUI();
            },
        }
    );
}

// for (let i = 0; i < document.querySelectorAll('.cam-button').length; i++) {
//     const cambtn = document.querySelectorAll('.cam-button')[i];
//     cambtn.onclick = () => {
//         var idx = Number(cambtn.getAttribute('data-index'));

//         console.log(idx);
//         // changeCamera(idx);
//         playCamera(idx);
//     };
// }

modelLoader.load(
    // resource URL
    './models/camera_v07.glb',
    // called when the resource is loaded
    function (gltf) {
        if (!use_orbit) {
            if (is_debug) {
                console.log('model loaded: camera glb ', gltf);
            }
            camera_gltf = gltf;

            camera = gltf.cameras[0];
            camera.near = 1;
            camera.fov = params.cameraFOV;
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            mixer = new THREE.AnimationMixer(gltf.scene);

            camera_animations = gltf.animations;
            if (is_debug) {
                console.log('camera anims', camera_animations);
            }
            camera_animations.forEach((clip) => {
                mixer.clipAction(clip).play();
            });

            if (add_gui) {
                controller_timeframe.max(camera_animations[0].duration);
            }
        }

        // console.log('cam', camera);

        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// LOAD GLB - SCENE
//////////////////////////////////////////////////////////////////

var scene_model;
var floor;
var plant_fromscene_arr = [];
var cloned_plants_arr = [];
var duneInstancedMesh;

modelLoader.load(
    // resource URL
    './models/Deeponde_glb_v021_grey.glb',
    // called when the resource is loaded
    function (gltf) {
        scene_model = gltf.scene;
        scene.add(scene_model);

        var childs_to_remove = [];
        var dunechilds = [];
        var base_dune;

        scene_model.traverse(function (child) {
            // if ( object.material ) materials.add( object.material );
            if (child.name != 'water' && child.material) {
                // change texture encoding of all textures
                if (child.material.emissiveMap != null) {
                    // child.material.emissiveMap.encoding = THREE.LinearEncoding;
                }
            }
            if (child.type == 'Mesh') {
                // console.log(child.name);

                if (child.name.includes('Plant')) {
                    plant_fromscene_arr.push(child);
                }

                // switch all materials to basic
                // console.log(child.name, child.material);
                if (child.name != 'title_shadow') {
                    var copy_emissivemap = child.material.emissiveMap;
                    if (copy_emissivemap) {
                        // copy_emissivemap.encoding = THREE.sRGBEncoding;
                        // copy_emissivemap.encoding = THREE.LinearEncoding;
                    }

                    var material_basic = new THREE.MeshBasicMaterial({
                        // color: child.color,
                        map: copy_emissivemap,

                        side: 0,
                    });
                    child.material = material_basic;
                } else {
                    // for title shadow only
                    var material_basic = new THREE.MeshBasicMaterial({
                        color: 0x000000,
                        side: 0,
                    });
                    child.material = material_basic;
                }

                if (child.name == 'Dune_title_ground') {
                    // all all these dunes for removal later on since we're using dune_1 for instancing
                    // childs_to_remove.push(child);
                }
                if (child.name == 'Dune_1' || child.name == 'Dune_2' || child.name == 'Dune_3' || child.name == 'Dune_4') {
                    // all all these dunes for removal later on since we're using dune_1 for instancing
                    childs_to_remove.push(child);
                    dunechilds.push(child);
                }

                if (child.name == 'Dune_3') {
                    // use dune_1 as base dune for instancing
                    base_dune = child;
                    childs_to_remove.push(child);
                    dunechilds.push(child);
                    // console.log('base dune', child.material);
                }
                if (child.name == 'DOME_half') {
                    const scale = new THREE.Vector3(1, 1, 1);
                    scale.x *= -1;
                    var duplicate_dome_half = child.clone();
                    duplicate_dome_half.rotation.y = -0.698;
                    duplicate_dome_half.scale.multiply(scale);
                    scene.add(duplicate_dome_half);
                }
                if (child.name == 'Bottom_half') {
                    const scale = new THREE.Vector3(1, 1, 1);
                    scale.x *= -1;
                    var duplicate_bottom_half = child.clone();
                    duplicate_bottom_half.rotation.y = 1.39615;
                    duplicate_bottom_half.scale.multiply(scale);
                    // console.log(duplicate_bottom_half);
                    scene.add(duplicate_bottom_half);

                    // console.log('base dune', child.material);
                }

                if (child.name == 'water') {
                    // base_dune = child;

                    childs_to_remove.push(child);
                }
            }
            // console.log(object);
        });

        /// CREATE INSTANCE DUNES

        const dune_count = 3;
        const dummy = new THREE.Object3D();
        const dune_group = new THREE.Group();

        var dune_Geometry = base_dune.geometry;
        var dune_Material = base_dune.material;
        duneInstancedMesh = new THREE.InstancedMesh(dune_Geometry, dune_Material, dune_count);
        // duneInstancedMesh.visible = false;
        dune_group.add(duneInstancedMesh);
        scene.add(dune_group);
        // console.log('DUNE INSTANCED', duneInstancedMesh);

        // fluo_group.quaternion.copy(room_steadyseller.children[0].quaternion);
        // fluo_group.position.copy(room_steadyseller.children[0].position);

        // set instanced positiions

        function setDuneData(dummy, i) {
            var new_pos = new THREE.Vector3();

            new_pos.x = dunechilds[i].parent.position.x;
            new_pos.y = dunechilds[i].parent.position.y;
            new_pos.z = dunechilds[i].parent.position.z;

            dummy.position.copy(new_pos);

            dummy.updateMatrix();
            duneInstancedMesh.setMatrixAt(i, dummy.matrix);
        }
        for (let i = 0; i < dune_count; i++) {
            setDuneData(dummy, i);
        }

        for (let i = 0; i < childs_to_remove.length; i++) {
            const child = childs_to_remove[i];
            child.geometry.dispose();
            child.material.dispose();
            child.removeFromParent();
            // console.log('remove', child.name);
        }

        // add floor

        floor = new THREE.Mesh(new THREE.PlaneGeometry(2400, 2400, 1));
        floor.material = new MeshReflectorMaterial(renderer, camera, scene, floor, {
            resolution: 1024,
            blur: [512, 128],
            mixBlur: 2.5,
            mixContrast: 1,
            mirror: 1,
        });

        floor.material.setValues({
            roughnessMap: new THREE.TextureLoader().load('./textures/roughness.jpg'),
            roughness: 0,
            normalMap: new THREE.TextureLoader().load('./textures/4141-normal.jpg'),
            normalScale: new THREE.Vector2(0.4, 0.4),
        });
        floor.material.normalMap.wrapS = THREE.RepeatWrapping;
        floor.material.normalMap.wrapT = THREE.RepeatWrapping;

        floor.position.y = -195;
        floor.rotation.x = Math.PI / -2;
        scene.add(floor);
        // console.log('floor', floor.material);
        checkLoadedState();

        // load plant after main scene is loaded
        loadPlantInstance();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

//////////////////////////////////////////////////////////////////
/// LOAD GLB - PLANT
//////////////////////////////////////////////////////////////////

var plant_model;
var leaf;

function loadPlantInstance() {
    modelLoader.load(
        // resource URL
        './models/plant_element.glb',
        // './models/plant_v02_low-v1.glb',
        // called when the resource is loaded
        function (gltf) {
            plant_model = gltf.scene;
            // console.log(plant_model, 'aksdjaj');
            // scene.add(plant_model);

            // console.log('plant model', plant_model);
            // console.log('plantarr', plant_fromscene_arr);

            plant_model.traverse(function (child) {
                // if ( object.material ) materials.add( object.material );

                if (child.type == 'Mesh') {
                    // console.log(child.name);
                    // var new_material = new THREE.MeshBasicMaterial({ map: child.material.emissiveMap });
                    // child.material = new_material;

                    if (child.name == 'Leaf') {
                        leaf = child;
                        initLeafInstance();
                    }
                }

                // console.log(object);
            });

            // for (let i = 0; i < plant_fromscene_arr.length; i++) {
            //     const single_plant_fromscene = plant_fromscene_arr[i];
            //     // console.log('plantfrom', single_plant_fromscene.position);

            //     var cloned_plant = plant_model.clone();
            //     cloned_plant.position.copy(single_plant_fromscene.position);
            //     cloned_plant.scale.copy(single_plant_fromscene.scale);
            //     cloned_plants_arr.push(cloned_plant);
            //     if (window.innerWidth > 600) {
            //         scene.add(cloned_plant);
            //     }
            // }

            for (let i = 0; i < plant_fromscene_arr.length; i++) {
                const child = plant_fromscene_arr[i];
                child.geometry.dispose();
                child.material.dispose();
                child.removeFromParent();
                // console.log('remove', child.name);
            }

            checkLoadedState();
        },
        // called while loading is progressing
        function (xhr) {
            // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
        },
        // called when loading has errors
        function (error) {
            console.log('An error happened', error);
        }
    );
}

function intRdm(min, max) {
    var val = Math.floor(Math.random() * (max - min + 1)) + min;
    return val;
}

// TREES
var trees = [];
var leafInstanceMesh;
var stemInstanceMesh;
var stemDummy = new THREE.Object3D();
var leafDummy = new THREE.Object3D();

function initLeafInstance() {
    stemDummy = new THREE.Object3D();
    leafDummy = new THREE.Object3D();

    let stemTotalCount = 0;
    let leafTotalCount = 0;

    // for (let i = 0; i < plant_fromscene_arr.length; i++) {
    //     const single_plant_fromscene = plant_fromscene_arr[i];
    //     // console.log('plantfrom', single_plant_fromscene.position);

    //     var cloned_plant = plant_model.clone();
    //     cloned_plant.position.copy(single_plant_fromscene.position);
    //     cloned_plant.scale.copy(single_plant_fromscene.scale);

    for (var i = 0; i < plant_fromscene_arr.length; i++) {
        const single_plant_fromscene = plant_fromscene_arr[i];

        var tree = new THREE.Group();
        tree.position.copy(single_plant_fromscene.position);
        if (i == 0) {
            // console.log('tree1', tree);
            tree.position.y -= 50;
        } else if (i == 1) {
            // console.log('tree2', tree);
            tree.position.y += 25;
        } else if (i == 7) {
            // console.log('tree7', tree);
            tree.position.x -= 20;
            tree.position.y += 0;
            tree.position.z += 35;
        }
        tree.scale.copy(single_plant_fromscene.scale);

        var scale_amt = 0.4;
        tree.scale.x = tree.scale.x * scale_amt;
        tree.scale.y = tree.scale.y * scale_amt;
        tree.scale.z = tree.scale.z * scale_amt;

        // tree.position.set(treePositions[i][0], treePositions[i][1], treePositions[i][2]);
        tree.branchArr = [];
        var branchCount = intRdm(window.innerWidth > 600 ? 12 : 8, window.innerWidth > 600 ? 16 : 12);
        for (var k = 0; k < branchCount; k++) {
            var branch = new THREE.Group();
            tree.add(branch);
            var radius = 20 + k * Math.random() * 3;
            var theta = (((360 / branchCount) * k + (-5 + Math.random() * 10)) * Math.PI) / 180;
            branch.position.x = 0 + Math.cos(theta) * radius;
            branch.position.z = 0 + Math.sin(theta) * radius;
            branch.rotation.y = -theta;
            branch.rotation.z = ((-15 + Math.random() * 30) * Math.PI) / 180;
            branch.stemArr = [];
            var stemCount = intRdm(4, 6);
            var stemDeg = 0;
            var stemPositionX = 0;
            var stemPositionY = 0;
            for (var m = 0; m < stemCount; m++) {
                var stemGroup = new THREE.Group();
                branch.add(stemGroup);
                var stemMesh = new THREE.Object3D();
                var stemLength = intRdm(90, 100);
                var thickness = 7 - m * 1.2;
                stemMesh.scale.set(stemLength, thickness, thickness);
                stemMesh.translateX(stemLength / 2);
                stemGroup.add(stemMesh);
                stemGroup.stemMesh = stemMesh;
                var randomDeg = intRdm(10, 16);
                stemDeg += randomDeg;
                stemGroup.rotation.z = (stemDeg * Math.PI) / 180;
                stemGroup.position.x = stemPositionX;
                stemGroup.position.y = stemPositionY;
                stemPositionX += Math.cos((stemDeg * Math.PI) / 180) * stemLength;
                stemPositionY += Math.sin((stemDeg * Math.PI) / 180) * stemLength;
                branch.stemArr.push(stemGroup);

                var leafCount = intRdm(window.innerWidth > 600 ? 3 : 2, window.innerWidth > 600 ? 5 : 4);
                var leafStep = stemLength / (Math.ceil(leafCount / 2) + 0);
                stemGroup.leafArr = [];
                for (var n = 0; n < leafCount; n++) {
                    var leafMesh = new THREE.Object3D();
                    var scaleX = 4 + Math.random() * 2;
                    var scaleZ = 4 + Math.random() * 2;
                    leafMesh.scale.set(scaleX, 3, scaleZ);
                    leafMesh.position.x = Math.floor(n / 2) * leafStep + (-5 + Math.random() * 20);
                    var trx = 5 + Math.random() * 15;
                    if (n % 2 == 1) {
                        leafMesh.rotation.y = (210 * Math.PI) / 180;
                        leafMesh.rotation.x = (-trx * Math.PI) / 180;
                    } else {
                        leafMesh.rotation.y = (-30 * Math.PI) / 180;
                        leafMesh.rotation.x = (trx * Math.PI) / 180;
                    }
                    stemGroup.add(leafMesh);
                    stemGroup.leafArr.push(leafMesh);
                    leafTotalCount += leafCount;
                }
            }
            stemTotalCount += stemCount;
            tree.branchArr.push(branch);
        }
        trees.push(tree);
    }

    // console.log('stem:', stemTotalCount, ' leaf:', leafTotalCount);

    //
    const stemGeometry = new THREE.BoxBufferGeometry(1, 1, 1);
    const stemMaterial = new THREE.MeshStandardMaterial({ color: 0xe4e4e4, side: THREE.DoubleSide, envMapIntensity: 1 });

    stemInstanceMesh = new THREE.InstancedMesh(stemGeometry, stemMaterial, stemTotalCount);
    // stemInstanceMesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage); // will be updated every frame
    scene.add(stemInstanceMesh);

    //
    const leafMaterial = new THREE.MeshStandardMaterial({ color: 0xe4e4e4, side: THREE.DoubleSide, envMapIntensity: 1, roughness: 0.5, metalness: 0.5 });

    // console.log('jajja', leaf);
    leafInstanceMesh = new THREE.InstancedMesh(leaf.geometry, leafMaterial, leafTotalCount);
    // leafInstanceMesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage); // will be updated every frame
    scene.add(leafInstanceMesh);

    updateLeaf();
}

function updateLeaf() {
    // console.log('update')

    if (stemInstanceMesh) {
        var stemCount = 0;
        var leafCount = 0;
        for (var i = 0; i < trees.length; i++) {
            var tree = trees[i];
            for (var k = 0; k < tree.branchArr.length; k++) {
                var branch = tree.branchArr[k];
                for (var m = 0; m < branch.stemArr.length; m++) {
                    var stemGroup = branch.stemArr[m];
                    var stemMesh = stemGroup.stemMesh;
                    stemMesh.getWorldPosition(stemDummy.position);
                    stemMesh.getWorldScale(stemDummy.scale);
                    stemMesh.getWorldQuaternion(stemDummy.quaternion);

                    stemDummy.updateMatrix();
                    stemInstanceMesh.setMatrixAt(stemCount, stemDummy.matrix);
                    stemCount++;

                    for (var n = 0; n < stemGroup.leafArr.length; n++) {
                        var leafMesh = stemGroup.leafArr[n];
                        leafMesh.getWorldPosition(leafDummy.position);
                        leafMesh.getWorldScale(leafDummy.scale);
                        leafMesh.getWorldQuaternion(leafDummy.quaternion);

                        leafDummy.updateMatrix();
                        leafInstanceMesh.setMatrixAt(leafCount, leafDummy.matrix);
                        leafCount++;
                    }
                }
            }
        }
        stemInstanceMesh.instanceMatrix.needsUpdate = true;
        leafInstanceMesh.instanceMatrix.needsUpdate = true;
    }

    //
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// CREATE INSTANCED VERTICAL POLES
//////////////////////////////////////////////////////////////////

var stick_instanced_arr = [];

var geom_h = 10;
// let poleGeometry = new THREE.BoxGeometry(0.075, geom_h, 0.075);
let poleGeometry = new THREE.BoxGeometry(12, geom_h, 12);
poleGeometry.translate(0, 0.5, 0);
poleGeometry.rotateY(Math.PI * 0.3);
// poleGeometry.rotateX(Math.PI * );
// console.log('poleGeom', poleGeometry);

var _rough = 0.5;
// const poleMaterials = [
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/right.jpg'), side: 2, envMapIntensity: 0.4, roughness: _rough }), //right side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/left.jpg'), side: 2, envMapIntensity: 0.4, roughness: _rough }), //left side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/right.jpg'), side: 2, envMapIntensity: 0.4, roughness: _rough }), //top side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/right.jpg'), side: 2, envMapIntensity: 0.4, roughness: _rough }), //bottom side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/front.jpg'), side: 2, envMapIntensity: 0.4, roughness: _rough }), //front side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/back.jpg'), side: 2, envMapIntensity: 0., roughness: _rough }), //back side
// ];

// let poleMaterial = new THREE.MeshBasicMaterial({
//     side: 2,
//     map: poleMaterials,
// });

const poleStandardMaterial = new THREE.MeshStandardMaterial({ color: 0xffffff, envMapIntensity: 1 });
// console.log('poleStickMat', poleStandardMaterial);
// const instancedStandardMaterials = new THREE.MeshStandardMaterial({ color: 0xfefefe });
class InstancedPattern {
    constructor(count, radius, formula, scaley) {
        this.pole_count = count;
        this.pole_radius = radius;
        this.formula = formula;
        this.scaley = scaley ? scaley : 1;
        this.pole_dummy = new THREE.Object3D();
        this.scales = new Float32Array(this.pole_count);

        this._position = new THREE.Vector3();
        this._positions = [];
        this._rotation = new THREE.Vector3();
        this._rotations = [];
        this._normal = new THREE.Vector3();
        this._normals = [];
        this.color = new THREE.Color();

        const clock = new THREE.Clock();

        this.meshGroup = new THREE.Group();
        this.meshGroup.visible = true;
        this.poleMesh = new THREE.InstancedMesh(poleGeometry, poleStandardMaterial, this.pole_count);
        this.poleMesh.userData.phases = [];
        this.poleMesh.castShadow = true;

        for (let i = 0; i < this.pole_count; i++) {
            this.setPoleData(this.pole_dummy, i);
        }

        this.meshGroup.add(this.poleMesh);
        // console.log(this.meshGroup);
        if (this.formula == 0) {
            this.meshGroup.rotation.y = 0.9;
        } else {
            this.meshGroup.rotation.y = -0.35;
        }

        scene.add(this.meshGroup);
        this.poleMesh.position.z = 0;
    }

    setPoleData(dummy, i) {
        var new_pos = new THREE.Vector3();

        if (this.formula == 1) {
            new_pos.x = Math.cos(i * ((Math.PI * 2) / this.pole_count)) * this.pole_radius;
            new_pos.z = Math.sin(i * ((Math.PI * 2) / this.pole_count)) * this.pole_radius;
        } else {
            new_pos.x = Math.sin(i * ((Math.PI * 2) / this.pole_count)) * this.pole_radius;
            new_pos.z = Math.cos(i * ((Math.PI * 2) / this.pole_count)) * this.pole_radius;
        }

        new_pos.y = 500;

        this._position.copy(new_pos);
        dummy.position.copy(this._position);

        var new_rot = new THREE.Vector3();

        new_rot.y = Math.PI / this.count;
        // this._rotation.copy(new_pos);
        // dummy.rotation.copy(this._rotation);

        this.scales[i] = 1;
        // dummy.scale.set(this.scales[i], this.scales[i], this.scales[i]);

        this._positions.push(this._position.clone());
        // this._rotations.push(this._rotation.clone());
        this._normals.push(this._normal.clone());

        dummy.updateMatrix();
        this.poleMesh.setMatrixAt(i, dummy.matrix);
    }

    rescale(i) {
        this.pole_dummy.position.copy(this._positions[i]);
        // this.pole_dummy.rotation.copy(this._rotations[i]);

        this.scales[i] = Math.sin(this.elapsedTime - i * 25) * (Math.PI * 1) * 15 + 80;
        var scale_y = this.scales[i] * this.scaley * 0.4;
        // this.pole_dummy.scale.set(this.scales[i] + 0.5, scale_y, this.scales[i] + 0.5);
        this.pole_dummy.scale.set(1 * global_instanced_scale.val, scale_y * global_instanced_scale.val, 1 * global_instanced_scale.val);
        this.pole_dummy.position.y = scale_y / -2 + 700;

        if (i == 0) {
            // console.log(this.scales[i]);
        }

        // this.pole_dummy.scale.set(1, this.scales[i], 1);

        this.pole_dummy.updateMatrix();

        this.poleMesh.setMatrixAt(i, this.pole_dummy.matrix);
    }

    tick() {
        this.elapsedTime = clock.getElapsedTime();
        for (let i = 0; i < this.pole_count; i++) {
            this.rescale(i, this.elapsedTime);
        }

        if (this.poleMesh) {
            this.poleMesh.instanceMatrix.needsUpdate = true;
        }
        if (this.meshGroup) {
            // this.meshGroup.rotation.y += this.formula == 0 ? 0.001 : -0.001;
        }
        // this.poleMeshGroup.rotation.y += this.formula == 0 ? 0.0025 : -0.0025;
    }
}

stick_instanced_arr[0] = new InstancedPattern(140 /*stickcount*/, 600 /*radius*/, 0 /*formula*/, 1 /*scaley*/);
stick_instanced_arr[1] = new InstancedPattern(70 /*stickcount*/, 350 /*radius*/, 1 /*formula*/, 0.8 /*scaley*/);

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// CREATE INSTANCED AXIS SPIRAL
//////////////////////////////////////////////////////////////////

var axisspiral_instanced_arr = [];
let axisspiralGeometry = new THREE.BoxGeometry(10, 10, 300);
// axisspiralGeometry.translate(0, 0, 100);

const instancedStandardMaterials2 = new THREE.MeshStandardMaterial({ color: 0xfefefe, envMapIntensity: 1.2 });
// console.log('contactStickMat', instancedStandardMaterials2);

class AxisspiralInstancedPattern {
    constructor(instIndex, count, radius, formula, scaleAmt) {
        this.instIndex = instIndex;
        this.axisspiral_count = count;
        this.axisspiral_radius = radius;
        this.formula = formula;

        this.axisspiral_dummy = new THREE.Object3D();
        this.scales = new Float32Array(this.axisspiral_count);
        this.scaleAmt = scaleAmt ? scaleAmt : 1;

        this._position = new THREE.Vector3();
        this._positions = [];
        this._rotation = new THREE.Vector3();
        this._rotations = [];
        this._normal = new THREE.Vector3();
        this._normals = [];
        this.color = new THREE.Color();

        this.meshGroup = new THREE.Group();
        this.meshGroup.visible = false;
        this.axisspiralMesh = new THREE.InstancedMesh(axisspiralGeometry, instancedStandardMaterials2, this.axisspiral_count);
        this.axisspiralMesh.rotation.y = this.instIndex * 0.15;
        // this.axisspiralMesh.position.x = this.instIndex * 50;
        this.axisspiralMesh.userData.phases = [];
        this.axisspiralMesh.castShadow = true;

        for (let i = 0; i < this.axisspiral_count; i++) {
            this.setAxisspiralData(this.axisspiral_dummy, i);
        }

        this.meshGroup.add(this.axisspiralMesh);
        // this.axisspiralMeshGroup.rotation.y = Math.PI / 2;

        scene.add(this.meshGroup);
        this.axisspiralMesh.position.z = 0;
    }

    setAxisspiralData(dummy, i) {
        var new_pos = new THREE.Vector3();
        new_pos.x = 0;
        new_pos.z = 0;

        new_pos.y = 350 + i * 15;

        this._position.copy(new_pos);
        dummy.position.copy(this._position);

        var new_rot = new THREE.Vector3();

        new_rot.y = Math.PI / this.count;
        // this._rotation.copy(new_pos);
        // dummy.rotation.copy(this._rotation);

        this.scales[i] = 1;
        dummy.scale.set(this.scales[i], this.scales[i], this.scales[i]);

        this._positions.push(this._position.clone());
        // this._rotations.push(this._rotation.clone());
        this._normals.push(this._normal.clone());

        dummy.updateMatrix();
        this.axisspiralMesh.setMatrixAt(i, dummy.matrix);
    }

    rescale(i) {
        this.axisspiral_dummy.position.copy(this._positions[i]);
        // this.axisspiral_dummy.rotation.copy(this._rotations[i]);

        this.scales[i] = (Math.sin(this.elapsedTime - i * 0.05) * 100 + 150) * this.scaleAmt;
        var scale_y = (this.scales[i] + 1) * 0.005;
        // this.axisspiral_dummy.scale.set(this.scales[i] + 0.5, scale_y, this.scales[i] + 0.5);
        this.axisspiral_dummy.scale.set(1 * global_instanced_scale.val, 1 * global_instanced_scale.val, scale_y * global_instanced_scale.val);

        // this.axisspiral_dummy.rotation.y = ((2 * Math.PI) / this.axisspiral_count) * i;
        this.axisspiral_dummy.rotation.y = Math.sin(this.elapsedTime / 5 + i * -0.015) * (Math.PI * 3);

        // this.axisspiral_dummy.rotation.x = Math.sin(this.elapsedTime + i * 0.05) * (Math.PI * 0.2);

        // if (i == 0) {
        //     console.log('0',this.axisspiral_dummy.rotation.x);
        // }

        // this.axisspiral_dummy.scale.set(1, this.scales[i], 1);

        this.axisspiral_dummy.updateMatrix();

        this.axisspiralMesh.setMatrixAt(i, this.axisspiral_dummy.matrix);
    }

    tick() {
        this.elapsedTime = clock.getElapsedTime();
        for (let i = 0; i < this.axisspiral_count; i++) {
            this.rescale(i, this.elapsedTime);
        }

        if (this.axisspiralMesh) {
            this.axisspiralMesh.instanceMatrix.needsUpdate = true;
        }
        if (this.meshGroup) {
            this.meshGroup.rotation.y += 0.005;
        }
        // this.axisspiralMeshGroup.rotation.y += this.formula == 0 ? 0.0025 : -0.0025;
    }
}

axisspiral_instanced_arr[0] = new AxisspiralInstancedPattern(0, 90 /*stickcount*/, 50 /*radius*/, 0 /*formula*/, 2.5 /*scaleAmt*/);

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// CREATE INSTANCED KINETIC PITAS
//////////////////////////////////////////////////////////////////

var pita_instanced_arr = [];
let pitaGeometry = new THREE.BoxGeometry(12, 12, 160);
pitaGeometry.translate(0, 0, 100);

const instancedStandardMaterials3 = new THREE.MeshStandardMaterial({ color: 0xfefefe, envMapIntensity: 1 });
// console.log('pitaStickMat', instancedStandardMaterials3);

// var _rough = 0.5;
// const pitaMaterials = [
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/right.jpg'), side: 2, envMapIntensity: 0.3, roughness: _rough }), //right side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/left.jpg'), side: 2, envMapIntensity: 0.3, roughness: _rough }), //left side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/right.jpg'), side: 2, envMapIntensity: 0.3, roughness: _rough }), //top side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/right.jpg'), side: 2, envMapIntensity: 0.3, roughness: _rough }), //bottom side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/front.jpg'), side: 2, envMapIntensity: 0.3, roughness: _rough }), //front side
//     new THREE.MeshStandardMaterial({ map: textureLoader.load('./textures/pole/new/back.jpg'), side: 2, envMapIntensity: 0.3, roughness: _rough }), //back side
// ];

class PitaInstancedPattern {
    constructor(instIndex, count, radius, formula, posy, scaleAmt) {
        this.instIndex = instIndex;
        this.pita_count = count;
        this.pita_radius = radius;
        this.formula = formula;
        this.posy = posy ? posy : 0;
        this.pita_dummy = new THREE.Object3D();
        this.scales = new Float32Array(this.pita_count);
        this.scaleAmt = scaleAmt ? scaleAmt : 1;

        this._position = new THREE.Vector3();
        this._positions = [];
        this._rotation = new THREE.Vector3();
        this._rotations = [];
        this._normal = new THREE.Vector3();
        this._normals = [];
        this.color = new THREE.Color();

        this.meshGroup = new THREE.Group();
        this.meshGroup.visible = false;
        this.pitaMesh = new THREE.InstancedMesh(pitaGeometry, instancedStandardMaterials3, this.pita_count);
        this.pitaMesh.scale.set(1.3, 1.3, 1.3);
        this.pitaMesh.rotation.y = this.instIndex * 0.15;
        // this.pitaMesh.position.x = this.instIndex * 50;
        this.pitaMesh.userData.phases = [];
        this.pitaMesh.castShadow = true;

        for (let i = 0; i < this.pita_count; i++) {
            this.setPitaData(this.pita_dummy, i);
        }

        this.meshGroup.add(this.pitaMesh);
        // this.pitaMeshGroup.rotation.y = Math.PI / 2;

        scene.add(this.meshGroup);
        this.pitaMesh.position.z = 0;
    }

    setPitaData(dummy, i) {
        var new_pos = new THREE.Vector3();

        if (this.formula == 1) {
            new_pos.x = Math.cos(i * ((Math.PI * 2) / this.pita_count)) * this.pita_radius;
            new_pos.z = Math.sin(i * ((Math.PI * 2) / this.pita_count)) * this.pita_radius;
        } else {
            new_pos.x = Math.sin(i * ((Math.PI * 2) / this.pita_count)) * this.pita_radius;
            new_pos.z = Math.cos(i * ((Math.PI * 2) / this.pita_count)) * this.pita_radius;
        }

        new_pos.y = 300 + this.posy;

        this._position.copy(new_pos);
        dummy.position.copy(this._position);

        var new_rot = new THREE.Vector3();

        new_rot.y = Math.PI / this.count;
        // this._rotation.copy(new_pos);
        // dummy.rotation.copy(this._rotation);

        this.scales[i] = 1;
        dummy.scale.set(this.scales[i], this.scales[i], this.scales[i]);

        this._positions.push(this._position.clone());
        // this._rotations.push(this._rotation.clone());
        this._normals.push(this._normal.clone());

        dummy.updateMatrix();
        this.pitaMesh.setMatrixAt(i, dummy.matrix);

        // this.pitaMesh.userData.phases.push({
        //     phaseX: (Math.random() - 0.5) * Math.PI * 2,
        //     phaseY: (Math.random() - 0.5) * Math.PI * 2,
        //     phaseZ: (Math.random() - 0.5) * Math.PI * 2,
        //     phaseDepth: Math.random() * Math.PI * 2,
        // });
    }

    rescale(i) {
        this.pita_dummy.position.copy(this._positions[i]);
        // this.pita_dummy.rotation.copy(this._rotations[i]);

        this.scales[i] = (Math.sin(this.elapsedTime - i * 0.05) * (Math.PI * 1) * 30 + 150) * this.scaleAmt;
        var scale_y = (this.scales[i] + 1) * 0.005;
        // this.pita_dummy.scale.set(this.scales[i] + 0.5, scale_y, this.scales[i] + 0.5);
        this.pita_dummy.scale.set(1 * global_instanced_scale.val, 1 * global_instanced_scale.val, scale_y * global_instanced_scale.val);
        this.pita_dummy.rotation.y = ((2 * Math.PI) / this.pita_count) * i;
        this.pita_dummy.rotation.x = Math.sin(this.elapsedTime + i * 0.05) * (Math.PI * 0.2);

        // if (i == 0) {
        //     console.log('0',this.pita_dummy.rotation.x);
        // }

        this.pita_dummy.updateMatrix();

        this.pitaMesh.setMatrixAt(i, this.pita_dummy.matrix);
    }

    tick() {
        this.elapsedTime = clock.getElapsedTime() / 2;
        for (let i = 0; i < this.pita_count; i++) {
            this.rescale(i, this.elapsedTime);
        }

        if (this.pitaMesh) {
            this.pitaMesh.instanceMatrix.needsUpdate = true;
        }
        if (this.meshGroup) {
            this.meshGroup.rotation.y += 0.001;
        }
        // this.pitaMeshGroup.rotation.y += this.formula == 0 ? 0.0025 : -0.0025;
    }
}

var height_gap = 200;
// pita_instanced_arr[0] = new PitaInstancedPattern(0, 150 /*stickcount*/, 50 /*radius*/, 0 /*formula*/, height_gap * 0 /*posy*/, 1 /*scaleAmt*/);
pita_instanced_arr[0] = new PitaInstancedPattern(0, 100 /*stickcount*/, 50 /*radius*/, 0 /*formula*/, height_gap * 0.1 /*posy*/, 1.1 /*scaleAmt*/);
pita_instanced_arr[1] = new PitaInstancedPattern(1, 100 /*stickcount*/, 140 /*radius*/, 0 /*formula*/, height_gap * 1 /*posy*/, 2 /*scaleAmt*/);
pita_instanced_arr[2] = new PitaInstancedPattern(2, 100 /*stickcount*/, 160 /*radius*/, 0 /*formula*/, height_gap * 2 /*posy*/, 2.5 /*scaleAmt*/);
pita_instanced_arr[3] = new PitaInstancedPattern(3, 100 /*stickcount*/, 140 /*radius*/, 0 /*formula*/, height_gap * 3 /*posy*/, 2 /*scaleAmt*/);
pita_instanced_arr[4] = new PitaInstancedPattern(4, 100 /*stickcount*/, 50 /*radius*/, 0 /*formula*/, height_gap * 3.9 /*posy*/, 1.1 /*scaleAmt*/);

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// MOUSE, WHEEL, SWIPE THREEJS INTERACTIONS
//////////////////////////////////////////////////////////////////

// used to reset wheel when stop scrolling
let stopWheelTimer;
function onStopWheel() {
    params.target_scrolly = 0;
}

function onWheel(e) {
    const normalized = normalizeWheel(event);

    // if (all_loaded) {
    params.target_scrolly = (normalized.pixelY / params.scrollspeed) * (params.speed_multiplier + (isSafariDesktop ? 1 : 0) + (os == 'windows' ? 3 : 0) - (isEdge ? 0.5 : 0));

    if (stopWheelTimer !== undefined) {
        clearTimeout(stopWheelTimer);
    }
    stopWheelTimer = setTimeout(() => onStopWheel(), 200);
    // }
}

var isDragging = false;

function onSwipe(e) {
    if (!all_loaded) return;

    params.target_scrolly = (e.deltaY / -1800) * params.speed_multiplier;

    if (stopWheelTimer !== undefined) {
        clearTimeout(stopWheelTimer);
    }
    stopWheelTimer = setTimeout(() => onStopWheel(), 200);

    isDragging = true;
}

// for desktop
// window.onwheel = onWheel;

/////////////

// for touch devices
// Observer.create({
//     target: window, // can be any element (selector text is fine)
//     type: 'touch', // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
//     dragMinimum: 10,
//     onUp: (ev) => {
//         onSwipe(ev);
//     },
//     onDown: (ev) => {
//         onSwipe(ev);
//     },
//     onRelease: (ev) => {
//         // console.log('released');
//         isDragging = false;
//     },
// });

////

function onPointerMove(event) {
    if (can_perspective) {
        pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
    } else {
        pointer.x = 0;
        pointer.y = 0;
    }

    params.mouse.target_x = pointer.x;
    params.mouse.target_y = pointer.y;
    // console.log(pointer.x, pointer.y);
}
function onPointerClick(event) {
    if (!all_loaded) return;
    if (event.target.tagName != 'CANVAS') return;
    if (window.innerWidth < 1024) {
        pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }
}

window.addEventListener('pointermove', onPointerMove);
// window.addEventListener('pointerup', onPointerClick);

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// RENDER TICK ANIMATE SCENE
//////////////////////////////////////////////////////////////////

var clock = new THREE.Clock();

/// TICK
function render() {
    // TO ADD -
    renderer.render(scene, camera);

    params.current_scrolly += (params.target_scrolly - params.current_scrolly) * params.ease_scrolly;

    const deltaTime = clock.getDelta();

    if (mixer) {
        if (!params.autoScroll) {
            mixer.update(params.current_scrolly);
        } else {
            mixer.update(deltaTime / 4);
        }
        if (add_gui) {
            params.frametime = mixer.time;
            controller_timeframe.updateDisplay();
        }

        const new_pos = new THREE.Vector3();
        camera_position = camera.getWorldPosition(new_pos);
        // console.log(camera_position);
    }

    if (is_debug) {
        if (stats) {
            stats.update();
        }
    }

    if (use_orbit) {
        controls.update();
    }

    if (window.innerWidth > 768) {
        params.mouse.current_x += (params.mouse.target_x - params.mouse.current_x) * params.mouse.ease;
        params.mouse.current_y += (params.mouse.target_y - params.mouse.current_y) * params.mouse.ease;
        if (can_perspective) {
            //

            // // console.log(params.mouse.current_x);
            if (scene_state == 'intro') {
                camera.position.x = camera_original_position[0].x + params.mouse.current_x * -100;
                camera.position.y = camera_original_position[0].y + params.mouse.current_y * -50;

                camera.quaternion.x = camera_original_quaternion[0].x + params.mouse.current_y / -20;
                camera.quaternion.y = camera_original_quaternion[0].y + params.mouse.current_x / 20;
            } else if (scene_state == 'about') {
                // camera.position.x = camera_original_position[1].x + params.mouse.current_x * 200;
            } else if (scene_state == 'origin') {
                // camera.position.x = camera_original_position[2].x + params.mouse.current_x * 200;
            } else if (scene_state == 'contact') {
                // camera.position.x = camera_original_position[3].x + params.mouse.current_x * 200;
            }
        }

        if (scene_state == 'intro') {
            document.querySelector('.intro-ui .logo-big').style.transform = 'rotateX(' + params.mouse.current_y * 15 + 'deg) rotateY(' + params.mouse.current_x * 10 + 'deg) scale(0.98)';
        } else if (scene_state == 'about') {
            // camera.position.x = camera_original_position[1].x + params.mouse.current_x * 200;
            document.querySelector('.about-ui .logo-big').style.transform = 'rotateX(' + params.mouse.current_y * 8 + 'deg) rotateY(' + params.mouse.current_x * 5 + 'deg)';
        } else if (scene_state == 'origin') {
            document.querySelector('.origin-ui .logo-big').style.transform = 'rotateX(' + params.mouse.current_y * 8 + 'deg) rotateY(' + params.mouse.current_x * 5 + 'deg)';
        } else if (scene_state == 'contact') {
            document.querySelector('.contact-ui .logo-big').style.transform = 'rotateX(' + params.mouse.current_y * 8 + 'deg) rotateY(' + params.mouse.current_x * 5 + 'deg)';
        }
    }

    // console.log(params.mouse.current_x);

    for (let i = 0; i < stick_instanced_arr.length; i++) {
        stick_instanced_arr[i].tick();
    }
    for (let i = 0; i < pita_instanced_arr.length; i++) {
        pita_instanced_arr[i].tick();
    }
    for (let i = 0; i < axisspiral_instanced_arr.length; i++) {
        axisspiral_instanced_arr[i].tick();
    }

    // camera.rotation.z = params.mouse.current_y / 50;
    // camera.rotation.y = params.mouse.current_x / -1000;
    // console.log(camera.rotation.y)

    if (floor) {
        floor.material.update();
        floor.material.normalMap.offset.x += 0.0003;
        floor.material.normalMap.offset.y += 0.000018;
    }

    requestAnimationFrame(render);
}

function onResize() {
    console.log('resize window');
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
}
window.onresize = onResize;

render();

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// PRELOADER FUNCTIONS
//////////////////////////////////////////////////////////////////

var preloader_count = { val: 0 };
var preloader_bar = document.querySelector('.progress-bar');
var preloader_progress = document.querySelector('.progress-percentage');

var second_arr = ['8', '9', '3', '4'];

function checkLoadedState() {
    loaded_models++;
    console.log('ld', loaded_models);

    if (loaded_models == total_models) {
        // IF ALL MODELS ARE LOADED

        params.frametime = window.innerWidth < 768 ? /*0.8*/ 0 : 0;
        updateSceneFromGUI();

        // copy positions and quaternion of intro camera
        camera.getWorldPosition(camera_original_position[0]);
        camera_original_quaternion[0].copy(camera.quaternion);

        // can_perspective = true;
        camera.quaternion.x -= window.innerWidth > 768 ? 0.55 : 0.6;

        gsap.to('.three-canvas-wrap', { opacity: 1, duration: 0.8, delay: 0.6 });

        if (show_preloader) {
            gsap.to(preloader_count, {
                val: 100,
                duration: 2,
                ease: 'power1.inOut',
                onUpdate: () => {
                    var val_touse = Math.round(preloader_count.val);
                    if (val_touse % 6 == 0) {
                        var random_num = Math.floor(Math.random() * 3);
                        preloader_progress.innerHTML = Math.round(preloader_count.val) < 10 ? 0 + '%' : (val_touse < 100 ? val_touse : val_touse - 1).toString().charAt(0) + second_arr[Math.round(preloader_count.val) < 90 ? random_num : 1] + '%';
                    }
                    if (window.innerWidth > 570) {
                        // preloader_bar.style.width = val_touse - 35 + '%';
                    }
                },
                onComplete: () => {
                    gsap.to('.preloader', {
                        opacity: 0,
                        display: 'none',
                        delay: 0.4,
                        duration: 1,
                        ease: 'power1.inOut',
                        onComplete: () => {
                            gsap.to(camera.quaternion, {
                                x: camera_original_quaternion[0].x,
                                y: camera_original_quaternion[0].y,
                                duration: 4,
                                ease: 'power1.inOut',
                                onComplete: () => {
                                    showIntroUI();
                                },
                            });
                            // goLanding();
                            // params.frametime = 0;
                            // updateSceneFromGUI();
                        },
                    });
                },
            });
        } else {
            document.querySelector('.preloader').remove();
            goLanding();
            params.frametime = 0;
            updateSceneFromGUI();
        }

        if (is_debug) {
            console.log('all loaded');
        }
    }
}

function updateSceneFromGUI(val) {
    if (add_gui && !use_orbit) {
        if (mixer) {
            mixer.setTime(params.frametime);
        }
        // console.log(params);
        controller_timeframe.updateDisplay();

        camera.fov = params.cameraFOV;
        camera.updateProjectionMatrix();
    }
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// KEYBOARD SHORTCUTS
//////////////////////////////////////////////////////////////////

document.addEventListener('keydown', function (e) {
    // console.log(camera.position, scene.children);
    if (is_debug) {
        // console.log(e.keyCode, scene.children, camera);
    }
    if (e.keyCode == 27) {
        // ESCAPE KEY
        if (document.querySelector('.overlay-about').style.display != 'none') {
            closeContent('about');
        }
        if (document.querySelector('.overlay-origin').style.display != 'none') {
            closeContent('origin');
        }
        if (document.querySelector('.overlay-contact').style.display != 'none') {
            closeContent('contact');
        }
    } else if (e.keyCode == 192) {
        // KEY `
        if (!is_debug) return;
        // params.jumpto_start();
    } else if (e.keyCode == 49) {
        // NUM 1
        if (!is_debug) return;
        // params.jumpto_dome();
    } else if (e.keyCode == 50) {
        // NUM 2
        if (!is_debug) return;

        // toggleInstanced();
        // for (let i = 0; i < stick_instanced_arr.length; i++) {
        //     stick_instanced_arr[i].meshGroup = false;
        // }
    }
});

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// CTA BUTTONS HOVER AND CLICK FUNCTIONS
//////////////////////////////////////////////////////////////////

var tl_arrowhover_playing_arr = [];
var tl_arrowhover_tl_arr = [];
for (let i = 0; i < document.querySelectorAll('.cta-button').length; i++) {
    const single_cta = document.querySelectorAll('.cta-button')[i];

    tl_arrowhover_playing_arr[i] = false;
    tl_arrowhover_tl_arr[i] = gsap.timeline({ paused: true });

    tl_arrowhover_tl_arr[i].to(single_cta.querySelector('.cta-circle .inner'), {
        x: '0%',
        ease: 'power3.inOut',
        duration: 1,
        onStart: () => {
            tl_arrowhover_playing_arr[i] = true;
        },
        onComplete: () => {
            tl_arrowhover_playing_arr[i] = false;
            gsap.set(single_cta.querySelector('.cta-circle .inner'), { x: '-100%' });
        },
    });

    single_cta.onmouseenter = () => {
        // console.log('over');
        if (!tl_arrowhover_playing_arr[i]) {
            tl_arrowhover_tl_arr[i].restart();
        }
    };
    single_cta.onmouseleave = () => {
        if (!tl_arrowhover_playing_arr[i]) {
            tl_arrowhover_tl_arr[i].restart();
        }
    };
    single_cta.onpointerdown = () => {
        // console.log('go');

        if (single_cta.classList.contains('cta-coupon')) return;
        // manual cta noclick remove for intro to landing
        preventDoubleClick(single_cta, scene_state == 'intro');

        if (scene_state == 'intro') {
            goLanding();
        } else if (scene_state == 'about') {
            // goAbout();
            showContent('about');
        } else if (scene_state == 'origin') {
            showContent('origin');
        } else if (scene_state == 'contact') {
            showContent('contact');
        }
    };
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// MENU ITEMS HOVER
//////////////////////////////////////////////////////////////////

var tl_menuhover_playing_arr = [];
var tl_menuhover_tl_arr = [];
for (let i = 0; i < document.querySelectorAll('.menu-item').length; i++) {
    const single_menuitem = document.querySelectorAll('.menu-item')[i];

    tl_menuhover_playing_arr[i] = false;
    tl_menuhover_tl_arr[i] = gsap.timeline({ paused: true });
    tl_menuhover_tl_arr[i].addLabel('start');
    tl_menuhover_tl_arr[i].to(
        single_menuitem.querySelector('.set-0 .number'),
        {
            y: '-81',
            ease: 'power3.inOut',
            duration: 1,
            delay: 0.1,
            onStart: () => {
                tl_menuhover_playing_arr[i] = true;
            },
            onComplete: () => {
                tl_menuhover_playing_arr[i] = false;
                gsap.set(single_menuitem.querySelector('.set-0 .number'), { y: 0 });
            },
        },
        'start'
    );
    tl_menuhover_tl_arr[i].to(
        single_menuitem.querySelector('.set-1 .number'),
        {
            y: '-81',
            ease: 'power3.inOut',
            duration: 1,
            delay: 0.1,
            onStart: () => {
                // tl_menuhover_playing_arr[i] = true;
            },
            onComplete: () => {
                // tl_menuhover_playing_arr[i] = false;
                gsap.set(single_menuitem.querySelector('.set-1 .number'), { y: 0 });
            },
        },
        'start'
    );

    tl_menuhover_tl_arr[i].to(
        single_menuitem.querySelector('.set-0 .menu-text'),
        {
            y: '-81',
            ease: 'power3.inOut',
            duration: 1,
            delay: 0.2,
            onStart: () => {
                // tl_menuhover_playing_arr[i] = true;
            },
            onComplete: () => {
                // tl_menuhover_playing_arr[i] = false;
                gsap.set(single_menuitem.querySelector('.set-0 .menu-text'), { y: 0 });
            },
        },
        'start'
    );

    tl_menuhover_tl_arr[i].to(
        single_menuitem.querySelector('.set-1 .menu-text'),
        {
            y: '-81',
            ease: 'power3.inOut',
            duration: 1,
            delay: 0.2,
            onStart: () => {
                // tl_menuhover_playing_arr[i] = true;
            },
            onComplete: () => {
                // tl_menuhover_playing_arr[i] = false;
                gsap.set(single_menuitem.querySelector('.set-1 .menu-text'), { y: 0 });
            },
        },
        'start'
    );

    single_menuitem.onmouseenter = () => {
        // console.log('over');
        if (!tl_menuhover_playing_arr[i]) {
            tl_menuhover_tl_arr[i].restart();
        }
        gsap.to(single_menuitem, { opacity: 1, duration: 0.4, ease: 'power1.inOut' });
    };
    single_menuitem.onmouseleave = () => {
        if (!tl_menuhover_playing_arr[i]) {
            // tl_menuhover_tl_arr[i].restart();
        }
        if (!single_menuitem.classList.contains('active')) {
            gsap.to(single_menuitem, { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
        }
    };
}

document.querySelector('.overlay-contact .can-hover').onmouseenter = () => {
    // console.log('over');
    if (window.innerWidth < 1024) return;
    gsap.to('.overlay-contact .section-0 .stairs-0 .stair-line .underline', { width: '100%', duration: 0.45, ease: 'power2.inOut' });
};
document.querySelector('.overlay-contact .can-hover').onmouseleave = () => {
    if (window.innerWidth < 1024) return;
    gsap.to('.overlay-contact .section-0 .stairs-0 .stair-line .underline', { width: 0, duration: 0.45, ease: 'power2.inOut' });
};
//////////////////////////////////////////////////////////////////
/// CLOSE BTN HOVER
//////////////////////////////////////////////////////////////////

var tl_closehover_playing_arr = [];
var tl_closehover_tl_arr = [];

for (let i = 0; i < document.querySelectorAll('.close-desktop').length; i++) {
    const single_closebtn = document.querySelectorAll('.close-desktop')[i];

    tl_closehover_playing_arr[i] = false;
    tl_closehover_tl_arr[i] = gsap.timeline({ paused: true });
    tl_closehover_tl_arr[i].addLabel('start');
    tl_closehover_tl_arr[i].to(
        single_closebtn.querySelector('.inner'),
        {
            y: '-50%',
            ease: 'power2.inOut',
            duration: 0.8,
            onStart: () => {
                tl_closehover_playing_arr[i] = true;
            },
            onComplete: () => {
                tl_closehover_playing_arr[i] = false;
                gsap.set(single_closebtn.querySelector('.inner'), { y: 0 });
            },
        },
        'start'
    );

    single_closebtn.onmouseenter = () => {
        // console.log('over');
        if (!tl_closehover_playing_arr[i]) {
            tl_closehover_tl_arr[i].restart();
        }
    };
    single_closebtn.onmouseleave = () => {
        if (!tl_closehover_tl_arr[i]) {
            // tl_menuhover_tl_arr[i].restart();
        }
    };
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// SCENE TO SCENE ANIMS FUNCTIONS
//////////////////////////////////////////////////////////////////

var dur_rotatecam = 5;

function goLanding() {
    can_perspective = false;
    document.body.classList.add('is-animating');

    var has_transitioned_landing_ui = false;
    var has_set_water = false;
    function setWaterNormalScale() {
        // make water normal less harsh when arriving at ground level
        // cause the water looks better harsher only when from top
        gsap.to(floor.material.normalScale, { x: 0.09, y: 0.09, duration: 1, ease: 'power1.inOut' });
    }

    console.log(floor.material);

    gsap.delayedCall(0, hideIntroUI);

    //RESET CAMERA FROM PERSPECTIVE PLAY
    gsap.to(camera.position, { x: camera_original_position[0].x, y: camera_original_position[0].y, duration: 1, ease: 'power2.inOut' });
    gsap.to(camera.quaternion, { x: camera_original_quaternion[0].x, y: camera_original_quaternion[0].y, duration: 1, ease: 'power2.inOut' });
    // gsap.to(camera.quaternion, { y: camera_original_quaternion[0].y, duration: 1, ease: 'inOut' });

    // CAMERA TWEEN TO NEXT SCENE
    gsap.fromTo(
        params,
        {
            frametime: window.innerWidth > 768 ? loc_intro.start : /*0.8*/ 0,
        },
        {
            frametime: loc_about.land,
            duration: 10,
            // duration: 5,
            delay: 1,
            ease: 'power1.inOut',
            onUpdate: (ev) => {
                updateSceneFromGUI();

                if (params.frametime > 9.8 && !has_set_water) {
                    has_set_water = true;
                    setWaterNormalScale();
                }

                /// SHOW CONTENTS ABIT EARLIER INSTEAD OF ONCOMPLETE, cause of tail skid
                if (params.frametime > 12 && !has_transitioned_landing_ui) {
                    has_transitioned_landing_ui = true;
                    if (show_preloader) {
                        setTimeout(() => {
                            document.body.classList.add('entered-landing');
                        }, 1500);

                        // gsap.to('.about-ui .logo-big', { opacity: 1, duration: 0.8, ease: 'power1.inOut' });
                        // gsap.to('.about-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile'), { opacity: 1, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
                        showAboutUI();
                    }

                    ////// hide all elements outside
                    for (let i = 0; i < cloned_plants_arr.length; i++) {
                        cloned_plants_arr[i].visible = false;
                    }
                    duneInstancedMesh.visible = false;
                    stemInstanceMesh.visible = false;
                    leafInstanceMesh.visible = false;

                    gsap.to('.menu .menu-item-0', {
                        opacity: 1,
                        duration: 0.8,
                        delay: 0.1,
                        ease: 'power1.inOut',
                    });
                    gsap.to('.menu .menu-item-1', {
                        opacity: 0.35,
                        duration: 0.8,

                        delay: 0.2,
                        ease: 'power1.inOut',
                    });
                    gsap.to('.menu .menu-item-2', {
                        opacity: 0.35,
                        duration: 0.8,

                        delay: 0.3,
                        ease: 'power1.inOut',
                        onComplete: () => {
                            // document.body.classList.add('entered-landing');
                            // document.querySelector((window.innerWidth > 1024 ? '.footer ' : '.logo-big ') + '.cta-discover').classList.remove('no-click');
                            // document.body.classList.remove('is-animating');
                            // gsap.set('.menu-item', { pointerEvents: 'auto' });
                            // scene_state = 'about';
                            // scene_history.push('about');
                            // all_loaded = true;
                            // updateMenu();
                            setTimeout(() => {
                                gsap.set('.menu-item', { pointerEvents: 'auto' });
                            }, 600);
                        },
                    });

                    document.body.classList.add('entered-landing');
                    document.querySelector((window.innerWidth > 1024 ? '.footer ' : '.logo-big ') + '.cta-discover').classList.remove('no-click');

                    document.body.classList.remove('is-animating');

                    scene_state = 'about';
                    scene_history.push('about');

                    all_loaded = true;
                    // updateMenu();

                    if (window.innerWidth < 1025) {
                        gsap.to('.menu-trigger', { display: 'flex', opacity: 1, delay: 0.1, duration: 0.6, ease: 'power1.inOut' });
                    }
                }
                //////
            },
            onComplete: () => {
                console.log('intro ended');
                params.frametime = loc_about.start;
                updateSceneFromGUI();

                if (camera_original_quaternion[1].y == 0) {
                    //still unset, so we copy once only
                    camera.getWorldPosition(camera_original_position[1]);
                    camera_original_quaternion[1].copy(camera.quaternion);
                }
                can_perspective = true;
            },
        }
    );
}

function showCoupon() {
    gsap.to('.coupon', { display: 'flex', opacity: 1, duration: 0.8, delay: window.innerWidth > 600 ? 1.3 : 1.5, ease: 'power1.inOut' });
    gsap.to('.coupon-title', { opacity: 1, duration: 0.8, delay: window.innerWidth > 600 ? 1.3 + 0.2 : 1.7, ease: 'power1.inOut' });
    gsap.to('.coupon-text', { opacity: 1, duration: 0.8, delay: 1.3 + 0.3, ease: 'power1.inOut' });
    gsap.to('.coupon .cta-button', { opacity: 1, duration: 0.8, delay: window.innerWidth > 600 ? 1.3 + 0.5 : 1.9, ease: 'power1.inOut' });
}
function hideCoupon() {
    setTimeout(() => {
        gsap.to('.coupon', {
            opacity: 0,
            display: 'none',
            duration: 0.8,
            // ease: 'power1.inOut',
            onComplete: () => {
                gsap.set('.coupon', { display: 'none' });
                gsap.set('.coupon-title', { opacity: 0 });
                gsap.set('.coupon-text', { opacity: 0 });
                gsap.set('.coupon .cta-button', { opacity: 0 });
            },
        });
    }, 100);
}

function goAbout() {
    if (scene_state == 'about') return;
    can_perspective = false;

    console.log('go about', 'scene state:', scene_state);

    document.body.classList.add('is-animating');
    closeContent(null, true);

    if (scene_state == 'origin') {
        // from landed inside
        hideOriginUI();
    } else if (scene_state == 'contact') {
        // from origin
        hideContactUI();
    }

    document.querySelector('.menu-item-0').classList.add('active');
    document.querySelector('.menu-item-1').classList.remove('active');
    document.querySelector('.menu-item-2').classList.remove('active');

    gsap.to('.menu-item-0', { opacity: 1, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.menu-item-1', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.menu-item-2', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });

    //RESET CAMERA FROM PERSPECTIVE PLAY
    // if (scene_state == 'origin') {
    //     gsap.to(camera.position, { x: camera_original_position[2].x, duration: 0.6, ease: 'inOut' });
    // } else if (scene_state == 'contact') {
    //     gsap.to(camera.position, { x: camera_original_position[3].x, duration: 0.6, ease: 'inOut' });
    // }

    var ui_shown = false;

    gsap.delayedCall(0.2, scaleDownCurrentInstanced, [0]);

    gsap.fromTo(
        params,
        { frametime: scene_state == 'origin' ? loc_origin.land : loc_contact.start },
        {
            frametime: scene_state == 'origin' ? loc_about.start : loc_contact.end,
            // duration: 1,
            // duration: (scene_state == 'origin' ? -0.4 : 0) + dur_rotatecam,
            duration: dur_rotatecam + (scene_state == 'contact' ? 0.4 : 0),
            ease: 'power1.inOut',
            // ease: 'linear',
            delay: 0.2,

            onUpdate: function () {
                // console.log(can_perspective);
                if (!ui_shown && this.progress() > (scene_state == 'contact' ? 0.75 : 0.8) && this.progress() < 0.91) {
                    // console.log(this.progress());
                    ui_shown = true;
                    showAboutUI();
                    scene_state = 'about';
                    scene_history.push('about');
                    can_perspective = true;
                }
                updateSceneFromGUI();
            },
            onComplete: () => {
                // in about
                console.log('NOW IN ABOUT');

                // showAboutUI();
                updateMenu();
            },
        }
    );
}
function goOrigin() {
    if (scene_state == 'origin') return;

    can_perspective = false;

    document.body.classList.add('is-animating');
    closeContent(null, true);

    //// HACK UPDATE MENU
    document.querySelector('.menu-item-0').classList.remove('active');
    document.querySelector('.menu-item-1').classList.add('active');
    document.querySelector('.menu-item-2').classList.remove('active');

    gsap.to('.menu-item-0', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.menu-item-1', { opacity: 1, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.menu-item-2', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });

    if (scene_state == 'about') {
        // from about
        hideAboutUI();
    } else if (scene_state == 'contact') {
        // from contact
        hideContactUI();
    }

    //RESET CAMERA FROM PERSPECTIVE PLAY
    // if (scene_state == 'about') {
    //     gsap.to(camera.position, { x: camera_original_position[1].x, duration: 0.6, ease: 'inOut' });
    // } else if (scene_state == 'contact') {
    //     gsap.to(camera.position, { x: camera_original_position[3].x, duration: 0.6, ease: 'inOut' });
    // }

    // gsap.to(camera.quaternion, { x: camera_original_quaternion[1].x, y: camera_original_quaternion[1].y, z: camera_original_quaternion[1].z, duration: 0.6, ease: 'inOut' });

    var ui_shown = false;
    gsap.delayedCall(0.2, scaleDownCurrentInstanced, [1]);

    gsap.fromTo(
        params,
        {
            frametime: scene_state == 'about' ? loc_about.start : loc_contact.land,
        },
        {
            frametime: scene_state == 'about' ? loc_origin.land : loc_origin.start,
            // duration: (scene_state == 'contact' ? 0.85 : scene_state == 'about' ? 0.3 : 0) + dur_rotatecam,
            duration: dur_rotatecam,
            // duration: 1,
            ease: 'power1.inOut',
            // ease: 'linear',
            delay: scene_state == 'contact' ? 0.5 : 0,

            onUpdate: function () {
                // console.log(can_perspective);
                if (!ui_shown && this.progress() > 0.8 && this.progress() < 0.87) {
                    // console.log(this.progress());
                    ui_shown = true;
                    showOriginUI();
                    scene_state = 'origin';
                    scene_history.push('origin');
                    can_perspective = true;
                }
                updateSceneFromGUI();
            },
            onComplete: () => {
                // in origin

                updateMenu();

                if (camera_original_quaternion[2].y == 0) {
                    //still unset, so we copy once only
                    camera.getWorldPosition(camera_original_position[2]);
                    camera_original_quaternion[2].copy(camera.quaternion);
                }
            },
        }
    );
}
function goContact() {
    if (scene_state == 'contact') return;

    can_perspective = false;

    document.body.classList.add('is-animating');
    closeContent(null, true);

    if (scene_state == 'about') {
        // from about
        hideAboutUI();
    } else if (scene_state == 'origin') {
        // from contact
        hideOriginUI();
    }

    //// HACK UPDATE MENU
    document.querySelector('.menu-item-0').classList.remove('active');
    document.querySelector('.menu-item-1').classList.remove('active');
    document.querySelector('.menu-item-2').classList.add('active');

    gsap.to('.menu-item-0', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.menu-item-1', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.menu-item-2', { opacity: 1, duration: 0.4, ease: 'power1.inOut' });

    //RESET CAMERA FROM PERSPECTIVE PLAY
    // if (scene_state == 'about') {
    //     gsap.to(camera.position, { x: camera_original_position[1].x, duration: 0.6, ease: 'inOut' });
    // } else if (scene_state == 'origin') {
    //     gsap.to(camera.position, { x: camera_original_position[2].x, duration: 0.6, ease: 'inOut' });
    // }
    // gsap.to(camera.quaternion, { y: camera_original_quaternion[2].y, duration: 0.6, ease: 'inOut' });

    var ui_shown = false;
    gsap.delayedCall(0.2, scaleDownCurrentInstanced, [2]);
    gsap.fromTo(
        params,
        {
            frametime: scene_state == 'about' ? loc_contact.end : loc_origin.start,
        },
        {
            frametime: scene_state == 'about' ? loc_contact.start : loc_contact.land,
            duration: dur_rotatecam,
            // duration: 1,
            ease: 'power1.inOut',
            // ease: 'linear',
            delay: 0.6,

            onUpdate: function () {
                // console.log(can_perspective);
                if (!ui_shown && this.progress() > 0.8 && this.progress() < 0.91) {
                    // console.log(this.progress());
                    ui_shown = true;

                    showContactUI();
                    scene_state = 'contact';
                    scene_history.push('contact');
                    can_perspective = true;
                }
                updateSceneFromGUI();
            },
            onComplete: () => {
                updateMenu();

                if (camera_original_quaternion[3].y == 0) {
                    //still unset, so we copy once only
                    camera.getWorldPosition(camera_original_position[3]);
                    camera_original_quaternion[3].copy(camera.quaternion);
                }
            },
        }
    );
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// SHOW / HIDE UI FUNCTIONS
//////////////////////////////////////////////////////////////////

function showIntroUI() {
    gsap.set('.intro-ui', { display: 'flex' });
    gsap.fromTo('.intro-ui .lockup', { y: window.innerWidth > 600 ? 30 : 15 }, { y: 0, duration: window.innerWidth > 600 ? 1 : 0.8, ease: 'power2.Out' });
    gsap.to('.intro-ui .logo-big', {
        opacity: 1,
        duration: 0.8,
        ease: 'power1.inOut',
        onComplete: () => {
            can_perspective = true;
        },
    });

    gsap.to('.intro-ui .footer-left', { opacity: 1, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
    // gsap.to('.footer-left', { y: -20, duration: 0.8, delay: 0.2, ease: 'power3.in' });

    gsap.to('.intro-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile'), { opacity: 1, duration: 0.8, delay: 0.4, ease: 'power1.inOut' });

    // gsap.to('.cta-button', { y: -20, duration: 0.8, delay: 0.4, ease: 'power3.in' });

    gsap.to('.copyright', { opacity: 1, duration: 0.8, delay: 0.5, ease: 'power1.inOut' });
    // gsap.to('.copyright', { y: -20, duration: 0.8, ease: 'power3.in' });

    gsap.to('.menu .logo', { opacity: 1, duration: 0.8, delay: 0.6, ease: 'power1.inOut' });

    if (window.innerWidth < 1025) {
        // gsap.to('.menu-trigger', { opacity: 1, duration: 0.8, delay: 0.6, ease: 'power1.inOut' });
    }
}
function hideIntroUI() {
    gsap.fromTo('.intro-ui .lockup', { y: 0 }, { y: window.innerWidth > 600 ? 30 : 15, duration: window.innerWidth > 600 ? 1.5 : 1, delay: 0, ease: 'power2.inOut' });
    gsap.to('.intro-ui .logo-big', { opacity: 0, duration: 1, delay: 0, ease: 'power1.inOut' });
    gsap.to('.intro-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), { opacity: 0, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
    gsap.to('.intro-ui .footer-left', { opacity: 0, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
    gsap.to('.copyright', {
        opacity: 0,
        duration: 0.8,
        delay: window.innerWidth > 600 ? 0.5 : 0.3,
        ease: 'power1.inOut',
        onComplete: () => {
            gsap.set('.intro-ui', { display: 'none' });
        },
    });
}

function showAboutUI() {
    gsap.set('.about-ui', { display: 'block' });
    gsap.fromTo('.about-ui .lockup', { y: window.innerWidth > 600 ? 30 : 15 }, { y: 0, duration: window.innerWidth > 600 ? 1 : 0.8, ease: 'power2.Out' });
    gsap.to('.about-ui .logo-big', { opacity: 1, duration: 0.8, ease: 'power1.inOut' });
    // gsap.to('.detail-dim', { opacity: window.innerWidth > 600 ? 0.3 : 0.55, delay: 0, duration: 0.8, ease: 'power1.inOut' });
    gsap.to('.about-ui .text-description', { opacity: 1, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
    gsap.to('.about-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), {
        opacity: 1,
        duration: 0.8,
        delay: window.innerWidth > 600 ? 0.4 : 0.2,
        ease: 'power1.inOut',
        onComplete: () => {
            document.body.classList.remove('is-animating');
        },
    });
}
function hideAboutUI() {
    // gsap.to('.detail-dim', { opacity: 0, duration: 0.3, ease: 'power1.inOut' });
    gsap.fromTo(
        '.about-ui .lockup',
        { y: 0 },
        {
            y: window.innerWidth > 600 ? 40 : 15,
            duration: window.innerWidth > 600 ? 1.2 : 1,
            delay: 0.2,
            ease: 'power2.inOut',
            onComplete: () => {
                gsap.set('.about-ui', { display: 'none' });
                gsap.set('.about-ui .logo-big', { clearProps: 'all' });
                // gsap.set('.detail-dim', { clearProps: 'all' });
                gsap.set('.about-ui .text-description', { clearProps: 'all' });
                gsap.set('.about-ui ' + (window.innerWidth > 1024 ? '.cta-desktop' : '.cta-mobile'), { clearProps: 'all' });
            },
        }
    );
    gsap.to('.about-ui .logo-big', { opacity: 0, duration: 0.8, delay: 0.3, ease: 'power1.inOut' });
    gsap.to('.about-ui .text-description', { opacity: 0, duration: 0.8, delay: 0.1, ease: 'power1.inOut' });
    gsap.to('.about-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), { opacity: 0, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
}

function showOriginUI() {
    gsap.set('.origin-ui', { display: 'block' });
    gsap.fromTo('.origin-ui .lockup', { y: window.innerWidth > 600 ? 40 : 15 }, { y: 0, duration: window.innerWidth > 600 ? 1 : 0.8, ease: 'power2.Out' });
    gsap.to('.origin-ui .logo-big', { opacity: 1, duration: 0.8, ease: 'power1.inOut' });
    // gsap.to('.detail-dim', { opacity: window.innerWidth > 600 ? 0.3 : 0.55, duration: 0.8, ease: 'power1.inOut' });
    gsap.to('.origin-ui .text-description', { opacity: 1, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
    gsap.to('.origin-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), {
        opacity: 1,
        duration: 0.8,
        delay: 0.4,
        ease: 'power1.inOut',
        onComplete: () => {
            document.body.classList.remove('is-animating');
        },
    });
}
function hideOriginUI() {
    gsap.fromTo(
        '.origin-ui .lockup',
        { y: 0 },
        {
            y: window.innerWidth > 600 ? 40 : 15,
            duration: window.innerWidth > 600 ? 1.2 : 1,
            delay: 0.2,
            ease: 'power2.inOut',
            onComplete: () => {
                gsap.set('.origin-ui', { display: 'none' });
                gsap.set('.origin-ui .logo-big', { clearProps: 'all' });
                gsap.set('.origin-ui .text-description', { clearProps: 'all' });
                gsap.set('.origin-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), { clearProps: 'all' });
            },
        }
    );

    gsap.to('.origin-ui .logo-big', { opacity: 0, duration: 0.8, delay: 0.3, ease: 'power1.inOut' });
    // gsap.to('.detail-dim', { opacity: 0, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.origin-ui .text-description', { opacity: 0, duration: 0.8, delay: 0.1, ease: 'power1.inOut' });
    gsap.to('.origin-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), { opacity: 0, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
}

function showContactUI() {
    gsap.set('.contact-ui', { display: 'block' });
    gsap.fromTo('.contact-ui .lockup', { y: window.innerWidth > 600 ? 30 : 15 }, { y: 0, duration: window.innerWidth > 600 ? 1 : 0.8, ease: 'power2.Out' });
    gsap.to('.contact-ui .logo-big', { opacity: 1, duration: 0.8, ease: 'power1.inOut' });
    // gsap.to('.detail-dim', { opacity: window.innerWidth > 600 ? 0.3 : 0.55, duration: 0.8, ease: 'power1.inOut' });
    gsap.to('.contact-ui .text-description', { opacity: 1, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
    gsap.to('.contact-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), {
        opacity: 1,
        duration: 0.8,
        delay: 0.4,
        ease: 'power1.inOut',
        onComplete: () => {
            document.body.classList.remove('is-animating');
        },
    });
}

function hideContactUI() {
    gsap.fromTo(
        '.contact-ui .lockup',
        { y: 0 },
        {
            y: window.innerWidth > 600 ? 40 : 15,
            duration: window.innerWidth > 600 ? 1.2 : 1,
            delay: 0.2,
            ease: 'power2.inOut',
            onComplete: () => {
                gsap.set('.contact-ui', { display: 'none' });
                gsap.set('.contact-ui .logo-big', { clearProps: 'all' });
                gsap.set('.contact-ui .text-description', { clearProps: 'all' });
                gsap.set('.contact-ui ' + (window.innerWidth > 1024 ? '.cta-desktop' : '.cta-mobile'), { clearProps: 'all' });
            },
        }
    );

    gsap.to('.contact-ui .logo-big', { opacity: 0, duration: 0.8, delay: 0.3, ease: 'power1.inOut' });
    // gsap.to('.detail-dim', { opacity: 0, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.contact-ui .text-description', { opacity: 0, duration: 0.8, delay: 0.1, ease: 'power1.inOut' });
    gsap.to('.contact-ui ' + (window.innerWidth > 1024 ? '.cta-desktop ' : '.cta-mobile '), { opacity: 0, duration: 0.8, delay: 0.2, ease: 'power1.inOut' });
}

function hideAllUI() {
    // hideIntroUI();
    if (document.querySelector('.origin-ui').style.display != 'none') {
        hideOriginUI();
    }
    if (document.querySelector('.about-ui').style.display != 'none') {
        hideAboutUI();
    }
    if (document.querySelector('.contact-ui').style.display != 'none') {
        hideContactUI();
    }
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// SHOW / HIDE CONTENT OVERLAYS
//////////////////////////////////////////////////////////////////

var has_init_trigger_about = false;

function showContent(which) {
    // gsap.to('.three-canvas-wrap', { x: '33%', duration: 1.6, delay: 0.3, ease: 'power2.inOut' });
    hideAllUI();
    document.body.classList.add('is-animating');
    //
    gsap.to('.overlay-' + which, {
        display: 'flex',
        opacity: 1,
        duration: 0.7,
        delay: 0.8,
        ease: window.innerWidth > 600 ? 'power2.Out' : 'power1.inOut',
        onStart: () => {},
        onComplete: () => {
            ScrollTrigger.refresh();
            document.body.classList.remove('is-animating');
        },
    });
    if (window.innerWidth > 600) {
        gsap.fromTo('.overlay-' + which, { x: '-100%' }, { x: '0%', ease: 'power2.Out', duration: 1.3, delay: 0.8 });
    } else {
        gsap.fromTo(
            '.overlay-' + which,
            { y: '5%' },
            {
                y: '0%',
                ease: 'power2.out',
                duration: 1,
                delay: 0.6,
                onComplete: () => {
                    gsap.to('.overlay-' + which + ' .close', { opacity: 1, ease: 'power1.inOut', duration: 0.6 });
                },
            }
        );
    }

    var amount_to_offset = 0;
    if (window.innerWidth > 1024) {
        amount_to_offset = '25vw';
    } else if (window.innerWidth <= 900 && window.innerWidth > 768) {
        amount_to_offset = '20vw';
    }

    if (window.innerWidth > 768) {
        gsap.to('.three-canvas-wrap', {
            x: '25vw',
            duration: 1.7,
            delay: 0.8,
            ease: 'power2.inOut',
        });
    }

    gsap.to('.menu-trigger', { opacity: 0, duration: 0.6, ease: 'power1.inOut' });

    // gsap.to('.detail-dim', { opacity: 0.45, duration: 1.6, ease: 'power1.inOut' });
    // gsap.to('.detail-dim', { scaleY: 2.1, duration: 1.6, ease: 'power2.inOut' });

    setTimeout(() => {
        document.querySelector('.overlay-' + which + ' .scroller').scrollTop = 0;
    }, 630);

    if (which == 'about') {
        gsap.fromTo('.overlay-about .section-0 .stair-line span', { opacity: 0 }, { opacity: 1, stagger: 0.08, delay: window.innerWidth > 600 ? 1.3 + 0.1 : 0.8, duration: 0.6, ease: 'power1.inOut' });
        gsap.fromTo('.overlay-about .section-0 .stair-line span', { y: 25 }, { y: 0, stagger: 0.08, duration: 0.6, delay: window.innerWidth > 600 ? 1.3 + 0.1 : 0.8, ease: 'power2.Out' });
        gsap.fromTo('.overlay-about .section-0 .small-text', { opacity: 0 }, { opacity: 1, stagger: 0.08, delay: 1.8 + 0.1, duration: 0.6, ease: 'power1.inOut' });
        // gsap.fromTo('.overlay-about .section-1 ', { opacity: 0 }, { opacity: 1, stagger: 0.08, delay: 1.8, duration: 0.6, ease: 'power1.inOut' });
    } else if (which == 'origin') {
        gsap.fromTo('.overlay-origin .section-0 .stairs-0 .stair-line span', { opacity: 0 }, { opacity: 1, stagger: 0.08, delay: window.innerWidth > 600 ? 1.3 + 0.1 : 1.1, duration: 0.7, ease: 'power1.inOut' });
        gsap.fromTo('.overlay-origin .section-0 .stairs-0 .stair-line span', { y: 25 }, { y: 0, stagger: 0.08, duration: 0.7, delay: window.innerWidth > 600 ? 1.3 + 0.1 : 1.1, ease: 'power2.Out' });
        gsap.fromTo('.overlay-origin .section-0 .image-wrap', { opacity: 0 }, { opacity: 1, duration: 0.9, delay: window.innerWidth > 600 ? 1.8 + 0.1 : 1.1, ease: 'power1.inOut' });

        showCoupon();
    } else if (which == 'contact') {
        gsap.fromTo('.overlay-contact .section-0 .stairs-0 .stair-line span', { opacity: 0 }, { opacity: 1, stagger: 0.08, delay: 1.3 + 0.3 - (window.innerWidth < 600 ? 0.3 : 0), duration: 0.7, ease: 'power1.inOut' });
        gsap.fromTo('.overlay-contact .section-0 .stairs-0 .stair-line span', { y: 25 }, { y: 0, stagger: 0.08, duration: 0.7, delay: 1.3 + 0.3 - (window.innerWidth < 600 ? 0.3 : 0), ease: 'power2.Out' });
        if (window.innerWidth < 1024) {
            gsap.fromTo('.overlay-contact .section-0 .stairs-0 .stair-line .underline', { width: 0 }, { width: '100%', stagger: 0.08, duration: 0.7, delay: 1 + 1 - (window.innerWidth < 600 ? 0.3 : 0), ease: 'power2.Out' });
        }

        gsap.fromTo('.overlay-contact .section-0 .small-text', { opacity: 0 }, { opacity: 1, stagger: 0.08, duration: 0.7, delay: 1.35 + 0.3 - (window.innerWidth < 600 ? 0.3 : 0), ease: 'power1.inOut' });

        gsap.fromTo('.overlay-contact .section-1 .stairs-0 .stair-line span', { opacity: 0 }, { opacity: 1, stagger: 0.08, delay: 1.5 + 0.3, duration: 0.7, ease: 'power1.inOut' });
        gsap.fromTo('.overlay-contact .section-1 .stairs-0 .stair-line span', { y: 25 }, { y: 0, stagger: 0.08, duration: 0.7, delay: 1.5 + 0.3 - (window.innerWidth < 600 ? 0.3 : 0), ease: 'power2.Out' });

        gsap.fromTo('.overlay-contact .section-1 .contact-cta', { opacity: 0 }, { opacity: 1, stagger: 0.08, duration: 0.7, delay: 1.6 + 0.3 - (window.innerWidth < 600 ? 0.3 : 0), ease: 'power1.inOut' });
        gsap.fromTo('.overlay-contact .section-1 .small-text', { opacity: 0 }, { opacity: 1, stagger: 0.08, duration: 0.7, delay: 1.7 + 0.3 - (window.innerWidth < 600 ? 0.3 : 0), ease: 'power1.inOut' });
    }

    if (document.querySelector('.overlay-' + which).getAttribute('data-hastriggered') == 'false') {
        // if scrolltrigger has not been initialised yet
        console.log('TRIGGER ONCE', which);
        document.querySelector('.overlay-' + which).setAttribute('data-hastriggered', 'true');

        //// image scaling
        gsap.utils.toArray('.overlay-' + which + ' .to-scale').forEach(function (section) {
            let tl_image_scale = gsap.timeline({
                scrollTrigger: {
                    scroller: '.overlay-' + which + ' .scroller',
                    trigger: section,
                    start: 'top 95%', // when the top of the trigger hits the top of the viewport
                    end: 'bottom top',
                    // markers: true,
                    scrub: 2.5,
                },
            });
            tl_image_scale.addLabel('start');
            tl_image_scale.to(section.querySelector(`${window.innerWidth > 768 ? '.img-desktop' : '.img-mobile'}`), { scale: 1.15 });
        });
        gsap.utils.toArray('.overlay-' + which + ' .to-stagger-line').forEach(function (section) {
            ScrollTrigger.create({
                scroller: '.overlay-' + which + ' .scroller',
                trigger: section,
                start: 'top 85%',
                once: true,
                // markers: true,
                onEnter: (self) => {
                    gsap.fromTo(section.querySelectorAll('.stair-line span'), { opacity: 0 }, { opacity: 1, stagger: 0.08, duration: 0.6, ease: 'power1.inOut' });
                    gsap.fromTo(section.querySelectorAll('.stair-line span'), { y: 25 }, { y: 0, stagger: 0.08, duration: 0.6, ease: 'power2.Out' });
                },
            });
        });
        //
        gsap.utils.toArray('.overlay-' + which + ' .text-wrap-big').forEach(function (section) {
            ScrollTrigger.create({
                scroller: '.overlay-' + which + ' .scroller',
                trigger: section,
                start: 'top 85%',
                once: true,
                // markers: true,
                onEnter: (self) => {
                    gsap.fromTo(section.querySelectorAll('.stair-line'), { opacity: 0 }, { opacity: 1, stagger: 0.08, duration: 0.6, ease: 'power1.inOut' });
                    gsap.fromTo(
                        section.querySelectorAll('.stair-line'),
                        { y: 25 },
                        {
                            y: 0,
                            stagger: 0.08,
                            duration: 0.6,
                            ease: 'power2.Out',
                            onComplete: () => {
                                gsap.fromTo(section.querySelectorAll('.small-text'), { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'power1.inOut' });
                            },
                        }
                    );
                },
            });
        });
        //
        gsap.utils.toArray('.overlay-' + which + ' .text-wrap-small').forEach(function (section) {
            ScrollTrigger.create({
                scroller: '.overlay-' + which + ' .scroller',
                trigger: section,
                start: 'top 85%',
                once: true,
                // markers: true,
                onEnter: (self) => {
                    gsap.fromTo(section.querySelector('.small-title'), { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'power1.inOut' });
                    gsap.fromTo(section.querySelector('.small-text'), { opacity: 0 }, { opacity: 1, duration: 0.6, delay: 0.2, ease: 'power1.inOut' });
                },
            });
        });

        /// footer scroll trigger  for origin footer only on mobile
        if (which == 'origin') {
            if (window.innerWidth < 600) {
                ScrollTrigger.create({
                    scroller: '.overlay-' + which + ' .scroller',
                    trigger: '.overlay-origin .section-footer',
                    start: 'top 90%',
                    // once: true,
                    // markers: true,
                    onEnter: (self) => {
                        if (!document.body.classList.contains('detail-open')) return;
                        gsap.to('.coupon', { opacity: 0, duration: 0.5, ease: 'power1.inOut' });
                    },
                    onLeaveBack: (self) => {
                        if (!document.body.classList.contains('detail-open')) return;
                        gsap.to('.coupon', { opacity: 1, duration: 0.5, ease: 'power1.inOut' });
                    },
                });
            }
        }
    }
    document.body.classList.add('detail-open');
}
function closeContent(which, from_topmenu) {
    if (window.innerWidth > 768) {
        gsap.to('.three-canvas-wrap', {
            x: '0%',
            duration: 1.3,
            ease: 'power2.inOut',
        });
    }

    // gsap.to('.three-canvas-wrap', { x: '0%', duration: 1.6, ease: 'power2.inOut' });
    if (document.querySelector('.overlay-about').style.display != 'none') {
        gsap.to('.overlay-about', { display: 'none', opacity: 0, duration: window.innerWidth > 768 ? 0.7 : 0.6, delay: window.innerWidth > 768 ? 1.2 : 0.2 });
        if (window.innerWidth > 600) {
            gsap.to('.overlay-about', { x: '-100%', ease: 'power2.inOut', duration: 1.3 });
        } else {
            gsap.to('.overlay-about', { y: '5%', ease: 'power2.in', duration: 0.6, delay: 0 });
            gsap.to('.overlay-about .close', { opacity: 0, ease: 'power1.inOut', duration: 0.6 });
        }
    }
    if (document.querySelector('.overlay-origin').style.display != 'none') {
        gsap.to('.overlay-origin', { display: 'none', opacity: 0, duration: window.innerWidth > 768 ? 0.7 : 0.6, delay: window.innerWidth > 768 ? 1.2 : 0.2 });

        if (window.innerWidth > 600) {
            gsap.to('.overlay-origin', { x: '-100%', ease: 'power2.inOut', duration: 1.3 });
        } else {
            gsap.to('.overlay-origin', { y: '5%', ease: 'power2.in', duration: 1 });
            gsap.to('.overlay-origin .close', { opacity: 0, ease: 'power1.inOut', duration: 0.6 });
        }
    }
    if (document.querySelector('.overlay-contact').style.display != 'none') {
        gsap.to('.overlay-contact', { display: 'none', opacity: 0, duration: window.innerWidth > 768 ? 0.7 : 0.6, delay: window.innerWidth > 768 ? 1.2 : 0.2 });

        if (window.innerWidth > 600) {
            gsap.to('.overlay-contact', { x: '-100%', ease: 'power2.inOut', duration: 1.3 });
        } else {
            gsap.to('.overlay-contact', { y: '5%', ease: 'power2.in', duration: 1 });
            gsap.to('.overlay-contact .close', { opacity: 0, ease: 'power1.inOut', duration: 0.6 });
        }
    }

    // dim
    // gsap.to('.detail-dim', { opacity: !from_topmenu ? (window.innerWidth > 600 ? 0.3 : 0.55) : 0, duration: window.innerWidth > 768 ? 1 : 0.6, delay: window.innerWidth < 768 ? 0.2 : !from_topmenu ? 0.2 : 1.2, ease: 'power1.inOut' });
    // gsap.to('.detail-dim', { scaleY: 1, duration: window.innerWidth > 768 ? 1 : 0.6, delay: window.innerWidth > 768 ? 1.2 : 0.2, ease: 'power2.inOut' });

    if (!from_topmenu) {
        if (scene_state == 'about') {
            gsap.delayedCall(0.4 + (window.innerWidth > 768 ? 0.5 : 0), showAboutUI);
        } else if (scene_state == 'origin') {
            gsap.delayedCall(0.4 + (window.innerWidth > 768 ? 0.5 : 0), showOriginUI);
        } else if (scene_state == 'contact') {
            gsap.delayedCall(0.4 + (window.innerWidth > 768 ? 0.5 : 0), showContactUI);
        }
        document.body.classList.add('is-animating');
    }

    //
    document.body.classList.remove('detail-open');
    if (window.innerWidth < 1025) {
        gsap.to('.menu-trigger', { opacity: 1, duration: 0.6, ease: 'power1.inOut', delay: 1.2 });
    }

    if (which) {
        console.log('close', which);
        gsap.delayedCall(0.4 + (window.innerWidth > 768 ? 1.2 : 0.3), resetScrollPos, [which]);
    }

    // if (document.querySelector('.coupon').style.opacity != '0') {
    // }
    hideCoupon();
}

function resetScrollPos(which) {
    console.log(which);
    document.querySelector('.overlay-' + which + ' .scroller').scrollTop = 0;
}

function updateMenu() {
    if (scene_state == 'about') {
        document.querySelector('.menu-item-0').classList.add('active');
        document.querySelector('.menu-item-1').classList.remove('active');
        document.querySelector('.menu-item-2').classList.remove('active');

        gsap.to('.menu-item-0', { opacity: 1, duration: 0.4, ease: 'power1.inOut' });
        gsap.to('.menu-item-1', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
        gsap.to('.menu-item-2', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
    } else if (scene_state == 'origin') {
        document.querySelector('.menu-item-0').classList.remove('active');
        document.querySelector('.menu-item-1').classList.add('active');
        document.querySelector('.menu-item-2').classList.remove('active');

        gsap.to('.menu-item-0', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
        gsap.to('.menu-item-1', { opacity: 1, duration: 0.4, ease: 'power1.inOut' });
        gsap.to('.menu-item-2', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
    } else if (scene_state == 'contact') {
        document.querySelector('.menu-item-0').classList.remove('active');
        document.querySelector('.menu-item-1').classList.remove('active');
        document.querySelector('.menu-item-2').classList.add('active');

        gsap.to('.menu-item-0', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
        gsap.to('.menu-item-1', { opacity: 0.35, duration: 0.4, ease: 'power1.inOut' });
        gsap.to('.menu-item-2', { opacity: 1, duration: 0.4, ease: 'power1.inOut' });
    }
}
function resetMenu() {
    document.querySelector('.menu-item-0').classList.remove('active');
    document.querySelector('.menu-item-1').classList.remove('active');
    document.querySelector('.menu-item-2').classList.remove('active');
}

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// MENU CLICKS
//////////////////////////////////////////////////////////////////

document.querySelector('.menu-item-0').onclick = () => {
    goAbout();

    document.querySelector('.menu-item-0').classList.add('active');
    document.querySelector('.menu-item-1').classList.remove('active');
    document.querySelector('.menu-item-2').classList.remove('active');
};
document.querySelector('.mobile-menu-item-0').onclick = () => {
    goAbout();
    closeMobileMenu();
};
document.querySelector('.menu-item-1').onclick = () => {
    goOrigin();

    document.querySelector('.menu-item-0').classList.remove('active');
    document.querySelector('.menu-item-1').classList.add('active');
    document.querySelector('.menu-item-2').classList.remove('active');
};
document.querySelector('.mobile-menu-item-1').onclick = () => {
    goOrigin();
    closeMobileMenu();
};
document.querySelector('.menu-item-2').onclick = () => {
    goContact();
    document.querySelector('.menu-item-0').classList.remove('active');
    document.querySelector('.menu-item-1').classList.remove('active');
    document.querySelector('.menu-item-2').classList.add('active');
};
document.querySelector('.mobile-menu-item-2').onclick = () => {
    goContact();
    closeMobileMenu();
};

/////

document.querySelector('.show-about').onclick = () => {
    if (document.querySelector('.overlay-origin').style.display != 'none') {
        closeContent('origin');
        closeContent('contact');
    }
    showContent('about');
};
document.querySelector('.show-origin').onclick = () => {
    if (document.querySelector('.overlay-about').style.display != 'none') {
        closeContent('about');
        closeContent('contact');
    }
    showContent('origin');
};
document.querySelector('.show-contact').onclick = () => {
    if (document.querySelector('.overlay-contact').style.display != 'none') {
        closeContent('about');
        closeContent('origin');
    }
    showContent('contact');
};
for (let i = 0; i < document.querySelectorAll('.close').length; i++) {
    document.querySelectorAll('.close')[i].onclick = () => {
        closeContent(document.querySelectorAll('.close')[i].getAttribute('data-id'));
    };
}

// click on dim
document.querySelector('.detail-dim').onclick = () => {
    if (!document.body.classList.contains('detail-open')) return;
    if (document.body.classList.contains('is-animating')) return;

    console.log('click dim to close');

    if (document.querySelector('.overlay-about').style.display != 'none') {
        closeContent('about');
    }
    if (document.querySelector('.overlay-origin').style.display != 'none') {
        closeContent('origin');
    }
    if (document.querySelector('.overlay-contact').style.display != 'none') {
        closeContent('contact');
    }
};

//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
/// INSTANCE MESHES TOGGLERS
//////////////////////////////////////////////////////////////////

var active_instanced = 0;
function toggleInstanced() {
    if (active_instanced == 0) {
        showAxissprialInstanced();
        active_instanced = 1;
    } else if (active_instanced == 1) {
        showSticksInstanced();
        active_instanced = 2;
    } else {
        showPitaInstanced();
        active_instanced = 0;
    }
}
function setInstanced(val) {
    if (val == 0) {
        showSticksInstanced();
    } else if (val == 1) {
        showPitaInstanced();
    } else if (val == 2) {
        showAxissprialInstanced();
    }
}

function hideAllInstanced() {
    for (let i = 0; i < stick_instanced_arr.length; i++) {
        stick_instanced_arr[i].meshGroup.visible = false;
    }
    for (let i = 0; i < pita_instanced_arr.length; i++) {
        pita_instanced_arr[i].meshGroup.visible = false;
    }
    for (let i = 0; i < axisspiral_instanced_arr.length; i++) {
        axisspiral_instanced_arr[i].meshGroup.visible = false;
    }
}
function showSticksInstanced() {
    hideAllInstanced();
    for (let i = 0; i < stick_instanced_arr.length; i++) {
        stick_instanced_arr[i].meshGroup.visible = true;
    }
}
function showPitaInstanced() {
    hideAllInstanced();
    for (let i = 0; i < pita_instanced_arr.length; i++) {
        pita_instanced_arr[i].meshGroup.visible = true;
    }
}
function showAxissprialInstanced() {
    hideAllInstanced();
    for (let i = 0; i < axisspiral_instanced_arr.length; i++) {
        axisspiral_instanced_arr[i].meshGroup.visible = true;
    }
}

function scaleDownCurrentInstanced(val) {
    gsap.to(global_instanced_scale, {
        val: 0,
        duration: 1.6,
        ease: 'power2.inOut',
        onComplete: () => {
            // switch instanced
            // toggleInstanced();
            setInstanced(val);
            scaleUpCurrentInstanced();
        },
    });
}
function scaleUpCurrentInstanced() {
    gsap.to(global_instanced_scale, {
        val: 1,
        duration: 2.2,
        delay: 1.5,
        ease: 'power2.inOut',
        onComplete: () => {
            // reenable interactions?
        },
    });
}

////////////////

document.querySelector('.menu-trigger').onclick = () => {
    if (document.body.classList.contains('mobilemenu-open')) {
        closeMobileMenu();
    } else {
        openMobileMenu();
    }
};

function openMobileMenu() {
    document.body.classList.add('mobilemenu-open');
    gsap.to('.mobile-menu', { display: 'flex', opacity: 1, duration: 0.8, ease: 'power1.inOut' });
    gsap.fromTo('.mobile-menu', { y: 30 }, { y: 0, duration: 0.8, ease: 'power2.out' });

    gsap.fromTo('.mobile-menu-item', { opacity: 0 }, { opacity: 1, duration: 0.8, stagger: 0.1, ease: 'power1.inOut' });
    gsap.fromTo('.mobile-menu-item', { y: 20 }, { y: 0, duration: 0.8, stagger: 0.1, ease: 'power2.out' });
}
function closeMobileMenu() {
    document.body.classList.remove('mobilemenu-open');
    gsap.to('.mobile-menu', { display: 'none', opacity: 0, duration: 0.6, ease: 'power1.inOut' });
}

////////////////

function preventDoubleClick(element, manualoff) {
    element.classList.add('no-click');
    if (!manualoff) {
        setTimeout(() => {
            console.log('prevent double click', element);
            element.classList.remove('no-click');
        }, 2000);
    }
}

////////////////////////////////

// go back to home

////////////////////////////////

document.querySelector('.logo-desktop').onclick = () => {
    goBackHome();
};

function goBackHome() {
    //
    if (document.body.classList.contains('is-animating')) return;
    if (scene_state == 'intro') return;
    can_perspective = false;
    document.body.classList.add('is-animating');

    // hide UIs
    hideAllUI();
    gsap.set('.menu-item', { pointerEvents: 'none' });
    gsap.to('.links', {
        opacity: 0,
        duration: 0.8,
        ease: 'power1.inOut',
        onComplete: () => {},
    });

    gsap.to('.restart-bg', { display: 'flex', opacity: 1, duration: 1.5, delay: 0.5, ease: 'power1.inOut' });
    if (scene_state == 'about') {
        gsap.to(camera.quaternion, { x: 0.35 * (scene_history[scene_history.length - 2] == 'contact' ? -1 : 1), z: 0.07905 * (scene_history[scene_history.length - 2] == 'contact' ? -1 : 1), duration: 2, ease: 'power2.inOut' });
    } else if (scene_state == 'origin') {
        gsap.to(camera.quaternion, { x: 0.1236, y: -0.9349, z: 0.4922, duration: 2, ease: 'power2.inOut' });
    } else if (scene_state == 'contact') {
        gsap.to(camera.quaternion, { x: -0.26312, y: -0.71235, z: 0.285229, duration: 2, ease: 'power2.inOut' });
    }
    gsap.to(camera, {
        fov: 80,
        duration: 2,
        ease: 'power2.inOut',
        onUpdate: () => {
            // camera.updateProjectionMatrix();
        },
        onComplete: () => {
            resetScene();
        },
    });

    // fov 40
    //
}

function resetScene() {
    params.frametime = 0;
    updateSceneFromGUI();
    scene_state = 'intro';
    scene_history.push('intro');

    camera.quaternion.x = camera.quaternion.x -= window.innerWidth > 768 ? 0.55 : 0.6;
    document.body.classList.remove('entered-landing');

    // reset menu ui
    gsap.set('.menu .menu-item', { opacity: 0 });
    gsap.set('.links', { opacity: 1 });

    resetMenu();

    // reset instanced mesh
    setInstanced(0);

    ////// reshow all elements outside
    for (let i = 0; i < cloned_plants_arr.length; i++) {
        cloned_plants_arr[i].visible = true;
    }
    duneInstancedMesh.visible = true;
    stemInstanceMesh.visible = true;
    leafInstanceMesh.visible = true;

    // reset water normal
    floor.material.normalScale.x = 0.4;
    floor.material.normalScale.y = 0.4;

    // hide bg color and pan camera down again
    gsap.to('.restart-bg', {
        display: 'none',
        opacity: 0,
        duration: 0.6,
        ease: 'power1.inOut',
        onComplete: () => {
            gsap.to(camera.quaternion, {
                x: camera_original_quaternion[0].x,

                duration: 4,
                ease: 'power1.inOut',
                onComplete: () => {
                    showIntroUI();
                    can_perspective = true;
                    document.body.classList.remove('is-animating');
                },
            });
        },
    });
}

if (is_debug) {
    document.body.classList.add('debug');
}

// console.log('gs', gsap);
